import { MapContext as MP } from "..";
import { useState, useContext, useEffect } from "react";
import { Accordion, AccordionDetails } from "@mui/material";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import Swal from "sweetalert2";
import { Typography } from "antd";
import styled from "@emotion/styled";
import { RiTeamFill } from "react-icons/ri";
import { UserContext } from "../../../../App";
import QuickDate from "../../../../components/QuickDate";
import greyUser from "./../../../../assets/images/userGrey.png";
import FiberCompanySelector from "../../../../components/FiberCompanySelector";
import { ArrowForwardIosSharp } from "@mui/icons-material";
import MapHelper from "../MapHelper";
import React, { useImperativeHandle, forwardRef } from "react";
import SelectionMenu from "../../../SuperAdmin/Tags/components/SelectionMenu";
import { useSwipeable } from "react-swipeable";
import AsyncSelect from "react-select/async";
import FiberHouseApi from "../../../../API/FiberHouseApi";
const AccordionSummary = styled((props) => (
	<MuiAccordionSummary
		expandIcon={<ArrowForwardIosSharp color="black" size={20} />}
		{...props}
	/>
))(({ theme }) => ({
	backgroundColor:
		theme.palette.mode === "dark"
			? "rgba(255, 255, 255, .05)"
			: "rgba(0, 0, 0, 0)",
	border: "none",
	borderBottom: "1px solid black",
	boxShadow: "none",
	flexDirection: "row-reverse",
	padding: "0px",
	"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
		transform: "rotate(90deg)",
	},
	"& .MuiAccordionSummary-content": {
		marginLeft: theme.spacing(1),
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
	},
}));

const SearchFilters = forwardRef(
	({
		unassignedConvertedToCustomer,
		setUnassignedConvertedToCustomer,
		unassignedCreatedFrom,
		setUnassignedCreatedFrom,
		unassignedCreatedTo,
		setUnassignedCreatedTo,
		unassignedAcountStatus,
		setUnassignedAcountStatus,
		unassignedMapIcons,
		setUnassignedMapIcons,
		assignedMapIcons,
		setAssignedMapIcons,
		assignedConvertedToCustomer,
		setAssignedConvertedToCustomer,
		searchFiberHouses,
		assignedAcountStatus,
		setAssignedAcountStatus,
		assignedCreatedFrom,
		assignedCreatedTo,
		setAssignedCreatedFrom,
		setAssignedCreatedTo,
		assignedDateType,
		setAssignedDateType,
		unassignedDateType,
		setUnassignedDateType,
		defaultFiberCompanies,
		tags,
		setTags,
		mySelectedTags,
		setMySelectedTags,
		assignedSelectedTags,
		setAssignedSelectedTags,
		unassignedSelectedTags,
		setUnassignedSelectedTags,
		searchCriteria,
		setSearchCriteria,
		//My Leads Filters
		myLeadsEnabled,
		setMyLeadsEnabled,
		myLeadsCreatedFrom,
		setMyLeadsCreatedFrom,
		myLeadsCreatedTo,
		setMyLeadsCreatedTo,
		myLeadsConvertedToCustomer,
		setMyLeadsConvertedToCustomer,
		myLeadsAcountStatus,
		setMyLeadsAcountStatus,
		myLeadsMapIcons,
		setMyLeadsMapIcons,
		myLeadsUpdatedFrom,
		setMyLeadsUpdatedFrom,
		myLeadsUpdatedTo,
		setMyLeadsUpdatedTo,
		myLeadsReviewType,
		setMyLeadsReviewType,
		myLeadsQuickDate,
		setMyLeadsQuickDate,
		myLeadsSalesRepIds,
		setMyLeadsSalesRepIds,
		myLeadsDateType,
		setMyLeadsDateType,
		myLeadsRepToggle,
		setMyLeadsRepToggle,
		myLeadsProspectSold,
		setMyLeadsProspectSold,
		myLeadsFiberCompanyIds,
		setMyLeadsFiberCompanyIds,
		myLeadsCompanyWithName,
		setMyLeadsCompanyWithName,
		myLeadsSegment,
		setMyLeadsSegment,
		assignedSegment,
		setAssignedSegment,
		unassignedSegment,
		setUnassignedSegment,
		ref,
		combined,
		setCombined,
		setShowInactiveLeads,
		showInactiveLeads,
	}) => {
		const map = useContext(MP);
		const user = useContext(UserContext);
		const [areaCreated, setAreaCreated] = useState(false);
		const initialRender = React.useRef(true);
		const ready = React.useRef(false);
		const [screenWidth, setScreenWidth] = useState(window.innerWidth);
		const helper = new MapHelper();
		const [combinedConvertedToCustomer, setCombinedConvertedToCustomer] =
			useState(null);
		const [combinedAcountStatus, setCombinedAcountStatus] = useState(null);
		const [combinedProspectSold, setCombinedProspectSold] = useState(false);
		const [combinedDateType, setCombinedDateType] = useState("LastUpdated");
		const [combinedSelectedTags, setCombinedSelectedTags] = useState([]);
		const [combinedQuickDate, setCombinedQuickDate] = useState(null);
		const [combinedUpdatedFrom, setCombinedUpdatedFrom] = useState(null);
		const [combinedUpdatedTo, setCombinedUpdatedTo] = useState(null);
		const [combinedCompanyWithName, setCombinedCompanyWithName] =
			useState(null);
		const [combinedFiberCompanyIds, setCombinedFiberCompanyIds] = useState([]);
		const [combinedSalesOrgs, setCombinedSalesOrgs] = useState([]);
		const [combinedRepToggle, setCombinedRepToggle] = useState("AssignedTo");
		const [combinedSalesRepIds, setCombinedSalesRepIds] = useState([]);
		const [combinedMapIcons, setCombinedMapIcons] = useState(
			map.mapIcons.map((icon) => icon.id),
		);

		const segments = [
			"0",
			"1",
			"2",
			"CR2.6",
			"CR2.9",
			"CR2.10",
			"CR2.4",
			"CR2.13",
			"CR2.1",
			"CR2.8",
			"CR2.2",
			"CR2.12",
			"CR2.3",
			"CR2.15",
			"CR2.11",
			"CR2.16",
			"CR2.5",
			"CR2.14",
			"CR2.7",
			"CR2.17",
			"22",
			"15",
			"19",
			"12",
			"18",
			"20",
			"21",
			"23",
			"13",
			"14",
			"16",
			"6",
			"7",
			"11",
			"8",
			"17",
			"10",
			"24",
			"5",
			"9",
			"4",
			"KN3.9",
			"KN3.13",
			"KN3.2",
			"KN3.10",
			"KN3.1",
			"KN3.8",
			"KN3.12",
			"KN3.6",
			"KN3.3",
			"KN3.7",
			"KN3.5",
			"KN3.11",
			"KN3.4",
			"Mackenzie Creek 04",
			"LAD1.8",
			"LADTrails6.1",
			"Section 5",
			"Section 3",
			"LAD1.3",
			"Section 8",
			"LADBarton8.1",
			"RIO1.12",
			"RIO1.5",
			"RIO1.13",
			"RIO1.14",
			"RIO1.2",
			"RIO1.3",
			"RIO1.4",
			"RIO1.1",
			"RIO1.10",
			"RIO1.11",
			"RIO1.8",
			"RIO1.9",
			"RIO1.6",
			"RIO1.7",
			"KS7.1",
			"KS7.7",
			"KS7.5",
			"KS7.3",
			"KS6.5",
			"KS6.9",
			"KS6.4",
			"KS7.6",
			"KS7.8",
			"KS6.8",
			"KS6.7",
			"KS6.6",
			"KS6.3",
			"KS6.1",
			"KS6.2",
			"KS7.4",
			"KS7.2",
		];
		const stopRef = React.useRef(null);
		useEffect(() => {
			const handleResize = () => {
				setScreenWidth(window.innerWidth);
			};
			window.addEventListener("resize", handleResize);
			return () => {
				window.removeEventListener("resize", handleResize);
			};
		}, []);

		const refPassthrough = (el) => {
			handlers.ref(el);
			stopRef.current = el;
		};
		const handlers = useSwipeable({
			onSwiped: (eventData) => {
				eventData.event.stopPropagation();
			},
			onSwiping: (eventData) => {
				eventData.event.stopPropagation();
			},
			onSwipedDown: (eventData) => {
				eventData.event.stopPropagation();
			},
		});

		async function search() {
			Swal.fire({
				icon: "info",
				title: "Please Wait",
				text: "We are Searching Fiber Houses",
				allowOutsideClick: false,
				allowEscapeKey: false,
				allowEnterKey: false,
				showConfirmButton: false,
				showCancelButton: false,
				willOpen: () => {
					Swal.showLoading();
				},
			});
			await searchFiberHouses(true);
			setAreaCreated(false);
			Swal.close();
		}

		useEffect(() => {
			if (areaCreated && map.searchArea && map.searchArea.length > 0) {
				search();
			}
		}, [map.searchArea, areaCreated]);

		const quickDate = (date, setFrom, setTo) => {
			const formatDate = (date) => date.toLocaleDateString("en-CA"); // 'en-CA' format is YYYY-MM-DD

			if (date === "Today") {
				const today = new Date();
				setFrom(formatDate(today));
				setTo(formatDate(today));
			} else if (date === "Tomorrow") {
				let tomorrow = new Date();
				tomorrow.setDate(tomorrow.getDate() + 1);
				setFrom(formatDate(tomorrow));
				setTo(formatDate(tomorrow));
			} else if (date === "Yesterday") {
				let yesterday = new Date();
				yesterday.setDate(yesterday.getDate() - 1);
				setFrom(formatDate(yesterday));
				setTo(formatDate(yesterday));
			} else if (date === "This Week") {
				let today = new Date();
				let firstDay = new Date(
					today.setDate(today.getDate() - ((today.getDay() + 6) % 7)),
				);
				let lastDay = new Date(
					today.setDate(today.getDate() - today.getDay() + 7),
				);
				setFrom(formatDate(firstDay));
				setTo(formatDate(lastDay));
			} else if (date === "Next Week") {
				let today = new Date();
				let firstDay = new Date(
					today.setDate(today.getDate() - ((today.getDay() + 6) % 7) + 7),
				);
				let lastDay = new Date(
					today.setDate(today.getDate() - today.getDay() + 7),
				);
				setFrom(formatDate(firstDay));
				setTo(formatDate(lastDay));
			} else if (date === "Last Week") {
				let today = new Date();
				let firstDay = new Date(
					today.setDate(today.getDate() - ((today.getDay() + 6) % 7) - 7),
				);
				let lastDay = new Date(
					today.setDate(today.getDate() - today.getDay() + 7),
				);
				setFrom(formatDate(firstDay));
				setTo(formatDate(lastDay));
			} else if (date === "This Month") {
				let today = new Date();
				let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
				let lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
				setFrom(formatDate(firstDay));
				setTo(formatDate(lastDay));
			} else if (date === "Next Month") {
				let today = new Date();
				let firstDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);
				let lastDay = new Date(today.getFullYear(), today.getMonth() + 2, 0);
				setFrom(formatDate(firstDay));
				setTo(formatDate(lastDay));
			} else if (date === "Last Month") {
				let today = new Date();
				let firstDay = new Date(today.getFullYear(), today.getMonth() - 1, 1);
				let lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
				setFrom(formatDate(firstDay));
				setTo(formatDate(lastDay));
			} else if (date === "This Year") {
				let today = new Date();
				let firstDay = new Date(today.getFullYear(), 0, 1);
				let lastDay = new Date(today.getFullYear(), 11, 31);
				setFrom(formatDate(firstDay));
				setTo(formatDate(lastDay));
			} else if (date === "Last Year") {
				let today = new Date();
				let firstDay = new Date(today.getFullYear() - 1, 0, 1);
				let lastDay = new Date(today.getFullYear() - 1, 11, 31);
				setFrom(formatDate(firstDay));
				setTo(formatDate(lastDay));
			} else {
				setFrom("");
				setTo("");
			}
		};

		useEffect(() => {
			if (initialRender.current) {
				map.setTriggerSearch(false);
				initialRender.current = false;

				return;
			}

			const timer = setTimeout(
				() => {
					if (screenWidth > 1000 && !helper.isIpad()) {
						searchFiberHouses();
					} else {
						map.setTriggerSearch(true);
					}
				},
				screenWidth > 1000 && !helper.isIpad() ? 1000 : 100,
			);

			return () => clearTimeout(timer);
		}, [
			unassignedConvertedToCustomer,
			map.includeInvalid,
			map.includePaid,
			map.unassignedFiberCompanyIds,
			map.assignedFiberCompanyIds,
			map.mapIconToggle,
			map.assignedProspectSold,
			assignedDateType,
			unassignedDateType,
			map.assignedLeadsEnabled,
			map.unassignedLeadsEnabled,
			map.unassignedUpdatedFrom,
			map.unassignedUpdatedTo,
			unassignedAcountStatus,
			unassignedMapIcons,
			map.unassignedSalesOrgs,
			assignedMapIcons,
			assignedConvertedToCustomer,
			assignedAcountStatus,
			map.assignedUpdatedFrom,
			map.assignedUpdatedTo,
			map.assignedSalesOrgs,
			map.assignedSalesRepIds,
			map.assignedRepToggle,
			mySelectedTags,
			assignedSelectedTags,
			unassignedSelectedTags,
			map.myLeadsEnabled,
			myLeadsCreatedFrom,
			myLeadsCreatedTo,
			myLeadsUpdatedFrom,
			myLeadsUpdatedTo,
			myLeadsConvertedToCustomer,
			myLeadsAcountStatus,
			myLeadsMapIcons,
			myLeadsDateType,
			myLeadsRepToggle,
			myLeadsProspectSold,
			map.myLeadsFiberCompanyIds,
		]);

		const resetMyLeadFilters = async () => {
			const option = await Swal.fire({
				icon: "warning",
				title: "Are you sure?",
				text: "This will reset all My Leads search filters",
				showCancelButton: true,
				confirmButtonText: "Yes",
				cancelButtonText: "No",
			});

			if (!option.isConfirmed) {
				return;
			}

			map.setMyLeadsEnabled(true);
			setMyLeadsConvertedToCustomer(null);
			map.setMyLeadsAcountStatus("");
			setMyLeadsDateType("LastUpdated");
			setMyLeadsMapIcons(map.mapIcons.map((icon) => icon.id));
			map.setMyLeadsUpdatedFrom("");
			map.setMyLeadsUpdatedTo("");
			map.setIncludeInvalid(false);
			map.setIncludePaid(false);
			map.setMyLeadsQuickDate("All Time");
			map.setMyLeadsSalesRepIds(map.salesReps.map((rep) => rep.id));
			map.setMyLeadsRepToggle("AssignedTo");
			map.setMapIconToggle("CurrentMapIcon");
			map.setMyLeadsFiberCompanyIds([]);
			setMyLeadsCompanyWithName([]);
			setMySelectedTags([]);
		};

		const resetAssignedFilters = async () => {
			const option = await Swal.fire({
				icon: "warning",
				title: "Are you sure?",
				text: "This will reset all assigned search filters",
				showCancelButton: true,
				confirmButtonText: "Yes",
				cancelButtonText: "No",
			});

			if (!option.isConfirmed) {
				return;
			}

			map.setAssignedLeadsEnabled(true);
			setAssignedConvertedToCustomer(null);
			map.setAssignedAcountStatus("");
			setAssignedDateType("LastUpdated");
			setAssignedMapIcons(map.mapIcons.map((icon) => icon.id));
			map.setAssignedUpdatedFrom("");
			map.setAssignedUpdatedTo("");
			map.setAssignedSalesOrgs(map.salesOrg.map((org) => org.id));
			map.setShowDeactivatedAccounts(false);
			map.setIncludeInvalid(false);
			map.setIncludePaid(false);
			map.setAssignedQuickDate("All Time");
			map.setAssignedSalesRepIds(map.salesReps.map((rep) => rep.id));
			map.setAssignedRepToggle("AssignedTo");
			map.setMapIconToggle("CurrentMapIcon");
			map.setAssignedFiberCompanyIds([]);
			map.setAssignedCompanyWithName([]);
			setAssignedSelectedTags([]);
		};

		const resetUnassignedFilters = async () => {
			const option = await Swal.fire({
				icon: "warning",
				title: "Are you sure?",
				text: "This will reset all unassigned search filters",
				showCancelButton: true,
				confirmButtonText: "Yes",
				cancelButtonText: "No",
			});

			if (!option.isConfirmed) {
				return;
			}

			map.setUnassignedLeadsEnabled(true);
			setUnassignedConvertedToCustomer(null);
			map.setUnassignedAcountStatus("");
			setUnassignedDateType("LastUpdated");
			setUnassignedMapIcons(map.mapIcons.map((icon) => icon.id));
			map.setIncludeInvalid(false);
			map.setIncludePaid(false);
			map.setUnassignedUpdatedFrom("");
			map.setUnassignedUpdatedTo("");
			map.setUnassignedSalesOrgs(map.salesOrg.map((org) => org.id));
			map.setUnassignedQuickDate("All Time");
			map.setUnassignedFiberCompanyIds([]);
			map.setUnassignedCompanyWithName([]);
			setUnassignedSelectedTags([]);
		};

		const unassignedColor = () => {
			if (
				!map.unassignedLeadsEnabled ||
				map.unassignedSalesOrgs.length !== map.salesOrg.length ||
				unassignedMapIcons.length !== map.mapIcons.length ||
				unassignedConvertedToCustomer !== null ||
				unassignedAcountStatus !== null ||
				map.unassignedUpdatedFrom !== "" ||
				map.unassignedUpdatedTo !== "" ||
				map.unassignedQuickDate !== "All Time"
			) {
				return "red";
			} else {
				return "#E6E6E6";
			}
		};

		const assignedColor = () => {
			if (
				!map.assignedLeadsEnabled ||
				map.assignedSalesOrgs.length !== map.salesOrg.length ||
				map.assignedSalesRepIds.length !== map.salesReps.length ||
				assignedMapIcons.length !== map.mapIcons.length ||
				assignedConvertedToCustomer !== null ||
				assignedAcountStatus !== null ||
				map.assignedUpdatedFrom !== "" ||
				map.assignedUpdatedTo !== "" ||
				map.assignedQuickDate !== "All Time"
			) {
				return "red";
			} else {
				return "#E6E6E6";
			}
		};

		const resetAllFilters = async () => {
			const option = await Swal.fire({
				icon: "warning",
				title: "Are you sure?",
				text: "This will reset all search filters",
				showCancelButton: true,
				confirmButtonText: "Yes",
				cancelButtonText: "No",
			});

			if (!option.isConfirmed) {
				return;
			}

			if (user.userType === "SalesRep") {
				map.setMyLeadsEnabled(true);
				map.setUnassignedLeadsEnabled(false);
				map.setAssignedLeadsEnabled(false);
			} else {
				map.setMyLeadsEnabled(true);
				map.setUnassignedLeadsEnabled(true);
				map.setAssignedLeadsEnabled(true);
			}

			//myLeads
			setMyLeadsConvertedToCustomer(null);
			map.setMyLeadsAcountStatus("");
			setMyLeadsDateType("LastUpdated");
			setMyLeadsMapIcons(map.mapIcons.map((icon) => icon.id));
			map.setMyLeadsUpdatedFrom("");
			map.setMyLeadsUpdatedTo("");
			map.setIncludeInvalid(false);
			map.setMyLeadsQuickDate("All Time");
			map.setMyLeadsSalesRepIds(map.salesReps.map((rep) => rep.id));
			map.setMyLeadsRepToggle("AssignedTo");
			map.setMapIconToggle("CurrentMapIcon");
			map.setMyLeadsFiberCompanyIds([]);
			setMyLeadsCompanyWithName([]);
			setMySelectedTags([]);

			//assigned
			map.setAssignedSalesOrgs(map.salesOrg.map((org) => org.id));
			map.setShowDeactivatedAccounts(false);
			setAssignedConvertedToCustomer(null);
			map.setAssignedAcountStatus("");
			setAssignedDateType("LastUpdated");
			setAssignedMapIcons(map.mapIcons.map((icon) => icon.id));
			map.setAssignedUpdatedFrom("");
			map.setAssignedUpdatedTo("");
			map.setAssignedQuickDate("All Time");
			map.setAssignedSalesRepIds(map.salesReps.map((rep) => rep.id));
			map.setAssignedRepToggle("AssignedTo");
			map.setMapIconToggle("CurrentMapIcon");
			map.setAssignedFiberCompanyIds([]);
			map.setAssignedCompanyWithName([]);
			setAssignedSelectedTags([]);

			//unassigned
			setUnassignedConvertedToCustomer(null);
			map.setUnassignedAcountStatus("");
			setUnassignedDateType("LastUpdated");
			setUnassignedMapIcons(map.mapIcons.map((icon) => icon.id));
			map.setIncludeInvalid(false);
			map.setUnassignedUpdatedFrom("");
			map.setUnassignedUpdatedTo("");
			map.setUnassignedSalesOrgs(map.salesOrg.map((org) => org.id));
			map.setUnassignedQuickDate("All Time");
			map.setUnassignedFiberCompanyIds([]);
			map.setUnassignedCompanyWithName([]);
			setUnassignedSelectedTags([]);

			// Reset combined states
			if (combined) {
				setCombinedConvertedToCustomer(null);
				setCombinedAcountStatus("");
				setCombinedDateType("LastUpdated");
				setCombinedSelectedTags([]);
				setCombinedQuickDate("All Time");
				setCombinedUpdatedFrom("");
				setCombinedUpdatedTo("");
				setCombinedCompanyWithName([]);
				setCombinedFiberCompanyIds([]);
				setCombinedSalesOrgs(map.salesOrg.map((org) => org.id));
				setCombinedRepToggle("AssignedTo");
				setCombinedMapIcons(map.mapIcons.map((icon) => icon.id));
				setCombinedSalesRepIds(map.salesReps.map((rep) => rep.id));
			}
		};

		useImperativeHandle(ref, () => ({
			resetAllFilters,
		}));

		return (
			<div ref={refPassthrough} className="SearchFiltersDiv">
				{(user.userType === "SuperAdmin" ||
					user.userType === "SalesOrgAdmin") && (
					<div className="action_buttons" style={{ marginBottom: "1rem" }}>
						<button
							onClick={() => setCombined(true)}
							className={`${
								combined ? "active" : null
							} action_button focus:outline-none `}
						>
							{"Combined Filters"}
						</button>
						<button
							onClick={() => setCombined(false)}
							className={`${
								combined ? null : "active"
							} action_button focus:outline-none`}
						>
							{"Separate Filters"}
						</button>
					</div>
				)}
				<div className="TitleDiv">
					<h3 className="text-4xl font-bold text-center">Search Filters</h3>
				</div>

				{combined ? (
					<>
						<div
							style={{ marginBottom: "1rem" }}
							className="search_filter_container"
						>
							<button
								disabled={assignedColor() === "#E6E6E6"}
								style={{
									backgroundColor: assignedColor(),
								}}
								onClick={() => {
									resetAllFilters();
								}}
								className="reset_all_filters"
							>
								Reset Filters
							</button>
							<div className="w-full flex flex-col gap-2 m-2">
								<div className="w-full flex justify-between items-center">
									<Typography> {"Assigned Leads"} </Typography>
									<div className="switch">
										<div className="switch__2">
											<input
												onChange={(e) => {
													map.setAssignedLeadsEnabled(e.target.checked);
													if (e.target.checked) {
														map.setMyLeadsEnabled(false);
													}
												}}
												id="switch-2"
												type="checkbox"
												checked={map.assignedLeadsEnabled}
											/>
											<label for="switch-2"></label>
										</div>
									</div>
								</div>
								<div className="w-full flex justify-between items-center">
									<Typography> {"My Leads"}</Typography>
									<div className="switch">
										<div className="switch__2">
											<input
												onChange={(e) => {
													map.setMyLeadsEnabled(e.target.checked);
													if (e.target.checked) {
														map.setAssignedLeadsEnabled(false);
													}
													console.log(e.target.checked);
												}}
												id="switch-11"
												type="checkbox"
												checked={map.myLeadsEnabled}
											/>
											<label for="switch-11"></label>
										</div>
									</div>
								</div>
								<div className="w-full flex justify-between items-center">
									<Typography>{"Unassigned Leads"}</Typography>
									<div className="switch">
										<div className="switch__2">
											<input
												onChange={(e) => {
													map.setUnassignedLeadsEnabled(e.target.checked);
												}}
												id="switch-4"
												type="checkbox"
												checked={map.unassignedLeadsEnabled}
											/>
											<label for="switch-4"></label>
										</div>
									</div>
								</div>
							</div>
							<Accordion
								sx={{
									boxShadow: "none",
									width: "100%",
								}}
							>
								<AccordionSummary
									sx={{
										display: "flex",
										justifyContent: "space-between",
										alignItems: "center",
									}}
								>
									<Typography> {"More Filters"}</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="InputsDiv">
										<div className="InputDiv">
											<label htmlFor="combinedConvertedToCustomer">
												Lead Type
											</label>
											<select
												className="p-2 border-2 outline-none rounded-lg"
												name="combinedConvertedToCustomer"
												value={combinedConvertedToCustomer ?? "null"}
												onChange={(e) => {
													const value = e.target.value;
													setCombinedConvertedToCustomer(
														value !== "0"
															? value === "true"
																? true
																: value === "false"
																? false
																: null
															: null,
													);
													if (map.assignedLeadsEnabled === true) {
														setAssignedConvertedToCustomer(
															value !== "0"
																? value === "true"
																	? true
																	: value === "false"
																	? false
																	: null
																: null,
														);
													}
													if (map.unassignedLeadsEnabled === true) {
														setUnassignedConvertedToCustomer(
															value !== "0"
																? value === "true"
																	? true
																	: value === "false"
																	? false
																	: null
																: null,
														);
													}
													if (map.myLeadsEnabled === true) {
														setMyLeadsConvertedToCustomer(
															value !== "0"
																? value === "true"
																	? true
																	: value === "false"
																	? false
																	: null
																: null,
														);
													}
												}}
											>
												<option value="null">All</option>
												<option value="true">Customer</option>
												<option value="false">Hot Lead</option>
											</select>
										</div>
										<div className="InputDiv">
											<label>Segment</label>
											<AsyncSelect
												isMulti
												cacheOptions
												defaultOptions={segments.map((segment) => ({
													label: segment,
													value: segment,
												}))}
												loadOptions={(inputValue, callback) => {
													// Simple filter for demonstration; replace with API call if needed
													const filtered = segments
														.filter((segment) =>
															segment
																.toLowerCase()
																.includes(inputValue.toLowerCase()),
														)
														.map((segment) => ({
															label: segment,
															value: segment,
														}));
													callback(filtered);
												}}
												onChange={(selectedOptions) => {
													// selectedOptions is an array of { label, value }

													setUnassignedSegment(
														selectedOptions
															? selectedOptions.map((opt) => opt.value)
															: [],
													);

													setAssignedSegment(
														selectedOptions
															? selectedOptions.map((opt) => opt.value)
															: [],
													);

													setMyLeadsSegment(
														selectedOptions
															? selectedOptions.map((opt) => opt.value)
															: [],
													);
												}}
												classNamePrefix="react-select"
												placeholder="Select Segment(s)"
											/>
										</div>
										{combinedConvertedToCustomer !== false && (
											<div className="InputDiv">
												<label htmlFor="accountStatus">Account Status</label>
												<select
													className="p-2 border-2 outline-none rounded-lg"
													name="accountStatus"
													value={combinedAcountStatus}
													onChange={(e) => {
														setCombinedAcountStatus(
															e.target.value !== "0" ? e.target.value : null,
														);
														if (map.assignedLeadsEnabled === true) {
															e.target.value !== "0"
																? setAssignedAcountStatus(e.target.value)
																: setAssignedAcountStatus(null);
														}
														if (map.unassignedLeadsEnabled === true) {
															e.target.value !== "0"
																? setUnassignedAcountStatus(e.target.value)
																: setUnassignedAcountStatus(null);
														}
														if (map.myLeadsEnabled === true) {
															e.target.value !== "0"
																? setMyLeadsAcountStatus(e.target.value)
																: setMyLeadsAcountStatus(null);
														}
													}}
												>
													<option value="0">All</option>
													<option value="Sold">Sold</option>
													<option value="VerifiedSold">Verified Sold</option>
													<option value="PendingCancels">
														Pending Cancels
													</option>
													<option value="PendinReshcedules">
														Pending Reschedules
													</option>
													<option value="Missing">Missing</option>
													<option value={"Completed"}>Completed</option>
													<option value="Canceled">Canceled</option>
													<option value={"Scheduled"}>Pending Installs</option>
												</select>
											</div>
										)}
										{combinedConvertedToCustomer === false && (
											<div className="InputDiv">
												<label>Sold</label>
												<div
													style={{
														gridColumn: "span 1",
														width: "100%",
													}}
													className="switch"
												>
													<div className="switch__2">
														<input
															onChange={(e) => {
																setCombinedProspectSold(e.target.checked);
																if (map.assignedLeadsEnabled === true) {
																	map.setAssignedProspectSold(e.target.checked);
																}
																if (map.unassignedLeadsEnabled === true) {
																	map.setUnassignedProspectSold(
																		e.target.checked,
																	);
																}
																if (map.myLeadsEnabled === true) {
																	map.setMyLeadsProspectSold(e.target.checked);
																}
															}}
															id="switch-5"
															type="checkbox"
															checked={combinedProspectSold}
														/>
														<label for="switch-5"></label>
													</div>
												</div>
											</div>
										)}

										<div className="InputDiv">
											<label htmlFor="DateType">Date Type</label>
											<select
												value={combinedDateType}
												onChange={(e) => {
													setCombinedDateType(e.target.value);
													if (map.assignedLeadsEnabled === true) {
														setAssignedDateType(e.target.value);
													}
													if (map.unassignedLeadsEnabled === true) {
														setUnassignedDateType(e.target.value);
													}
													if (map.myLeadsEnabled === true) {
														setMyLeadsDateType(e.target.value);
													}
												}}
											>
												<option value={"LastUpdated"}>Last Updated</option>
												<option value={"DateSold"}>Date Sold</option>
												<option value={"InstallDate"}>Install Date</option>
												<option value={"AppointmentDate"}>
													Appointment Date
												</option>
												<option value={"CreatedAt"}>Created At</option>
												{/* <option value={"CancelRequestDate"}>Cancel Request Date</option> */}
											</select>
										</div>

										<SelectionMenu
											tags={tags}
											onChange={(selected) => {
												setCombinedSelectedTags(selected);
												if (map.assignedLeadsEnabled === true) {
													setAssignedSelectedTags(selected);
												}
												if (map.unassignedLeadsEnabled === true) {
													setUnassignedSelectedTags(selected);
												}
												if (map.myLeadsEnabled === true) {
													setMySelectedTags(selected);
												}
											}}
											value={combinedSelectedTags}
											selectedItems={combinedSelectedTags}
											setSelectedItems={setCombinedSelectedTags}
											searchCriteria={searchCriteria}
											setSearchCriteria={setSearchCriteria}
										/>

										<div className="InputDiv">
											<label hmltFor="include_invalid">Include Invalids</label>
											<div
												style={{
													gridColumn: "span 1",
													width: "100%",
												}}
												className="switch"
											>
												<div className="switch__2">
													<input
														onChange={(e) => {
															map.setIncludeInvalid(e.target.checked);
														}}
														id="switch-20"
														type="checkbox"
														checked={map.includeInvalid}
													/>
													<label for="switch-20"></label>
												</div>
											</div>
										</div>
										<div className="InputDiv">
											<label hmltFor="include_paid">Include Paid</label>
											<div
												style={{
													gridColumn: "span 1",
													width: "100%",
												}}
												className="switch"
											>
												<div className="switch__2">
													<input
														onChange={(e) => {
															map.setIncludePaid(e.target.checked);
														}}
														id="include_paid"
														type="checkbox"
														checked={map.includePaid}
													/>
													<label for="include_paid"></label>
												</div>
											</div>
										</div>

										<QuickDate
											future={combinedAcountStatus === "Scheduled"}
											selectQuickDate={combinedQuickDate}
											setQuickDateValue={(date) => {
												setCombinedQuickDate(date);
												if (map.assignedLeadsEnabled === true) {
													map.setAssignedQuickDate(date);
												}
												if (map.unassignedLeadsEnabled === true) {
													map.setUnassignedQuickDate(date);
												}
												if (map.myLeadsEnabled === true) {
													map.setMyLeadsQuickDate(date);
												}
											}}
											setFrom={(date) => {
												setCombinedUpdatedFrom(date);
												if (map.assignedLeadsEnabled === true) {
													map.setAssignedUpdatedFrom(date);
												}
												if (map.unassignedLeadsEnabled === true) {
													map.setUnassignedUpdatedFrom(date);
												}
												if (map.myLeadsEnabled === true) {
													map.setMyLeadsUpdatedFrom(date);
												}
											}}
											setTo={(date) => {
												setCombinedUpdatedTo(date);
												if (map.assignedLeadsEnabled === true) {
													map.setAssignedUpdatedTo(date);
												}
												if (map.unassignedLeadsEnabled === true) {
													map.setUnassignedUpdatedTo(date);
												}
												if (map.myLeadsEnabled === true) {
													map.setMyLeadsUpdatedTo(date);
												}
											}}
										/>
										<div className="company_selector">
											<FiberCompanySelector
												companyObject={combinedCompanyWithName}
												setCompanyObject={(e) => {
													setCombinedCompanyWithName(e);
													if (map.assignedLeadsEnabled === true) {
														map.setAssignedCompanyWithName(e);
													}
													if (map.unassignedLeadsEnabled === true) {
														map.setUnassignedCompanyWithName(e);
													}
													if (map.myLeadsEnabled === true) {
														map.setMyLeadsCompanyWithName(e);
													}
												}}
												multiple={true}
												setUser={(e) => {
													setCombinedFiberCompanyIds(e);
													if (map.assignedLeadsEnabled === true) {
														map.setAssignedFiberCompanyIds(e);
													}
													if (map.unassignedLeadsEnabled === true) {
														map.setUnassignedFiberCompanyIds(e);
													}
													if (map.myLeadsEnabled === true) {
														map.setMyLeadsFiberCompanyIds(e);
													}
												}}
												placeholder="Select Fiber Company"
											/>
										</div>
										{user.userType === "SuperAdmin" && (
											<>
												<h1 className="lead_type_title">Sales Orgs</h1>
												<div className="select_deselect">
													<button
														className="select"
														onClick={() => {
															setCombinedSalesOrgs(
																map.salesOrg.map((org) => org.id),
															);
															if (map.assignedLeadsEnabled === true) {
																map.setAssignedSalesOrgs(
																	map.salesOrg.map((org) => org.id),
																);
															}
															// if (map.unassignedLeadsEnabled === true) {
															//   map.setUnassignedSalesOrgs(
															//     map.salesOrg.map((org) => org.id)
															//   );
															// }
														}}
													>
														Select All
													</button>
													<button
														className="deselect"
														onClick={() => {
															map.setAssignedSalesOrgs([]);
															// map.setUnassignedSalesOrgs([]);
															setCombinedSalesOrgs([]);
														}}
													>
														Deselect All
													</button>
												</div>
												<div className="MapIconStats">
													{map.salesOrg?.map((org, index) => {
														return (
															<div
																style={{
																	// borderRadius: "10px",
																	width: "5rem",
																	height: "5rem",
																}}
																onClick={() => {
																	if (combinedSalesOrgs.includes(org.id)) {
																		setCombinedSalesOrgs(
																			combinedSalesOrgs?.filter(
																				(id) => id !== org.id,
																			),
																		);
																	} else {
																		setCombinedSalesOrgs([
																			...combinedSalesOrgs,
																			org.id,
																		]);
																	}
																	if (map.assignedLeadsEnabled === true) {
																		if (
																			map.assignedSalesOrgs.includes(org.id)
																		) {
																			map.setAssignedSalesOrgs(
																				map.assignedSalesOrgs?.filter(
																					(id) => id !== org.id,
																				),
																			);
																		} else {
																			map.setAssignedSalesOrgs([
																				...map.assignedSalesOrgs,
																				org.id,
																			]);
																		}
																	}
																	// if (map.unassignedLeadsEnabled === true) {
																	//   if (
																	//     map.unassignedSalesOrgs.includes(org.id)
																	//   ) {
																	//     map.setUnassignedSalesOrgs(
																	//       map.unassignedSalesOrgs?.filter(
																	//         (id) => id !== org.id
																	//       )
																	//     );
																	//   } else {
																	//     map.setUnassignedSalesOrgs([
																	//       ...map.unassignedSalesOrgs,
																	//       org.id,
																	//     ]);
																	//   }
																	// }
																}}
																className={`MapIconStat ${
																	combinedSalesOrgs.includes(org.id)
																		? "active"
																		: null
																}`}
																key={index}
															>
																<h3>
																	{org.icon ? (
																		<img
																			src={"data:image/png;base64," + org.icon}
																			alt="Map Icon"
																		/>
																	) : (
																		<RiTeamFill size={30} color="black" />
																	)}
																</h3>
																<p
																	style={{
																		textAlign: "center",
																		fontSize: "0.6rem",
																	}}
																>
																	{org.name}
																</p>
															</div>
														);
													})}
												</div>
											</>
										)}
										{(user.userType === "SuperAdmin" ||
											user.userType === "SalesOrgAdmin") && (
											<>
												<h1 className="lead_type_title">Sales Reps</h1>
												<div className="select_deselect">
													<button
														className="select"
														onClick={() => {
															setCombinedSalesRepIds(
																map.salesReps.map((rep) => rep.id),
															);
															if (map.assignedLeadsEnabled === true) {
																map.setAssignedSalesRepIds(
																	map.salesReps.map((rep) => rep.id),
																);
															}
															if (map.myLeadsEnabled === true) {
																map.setMyLeadsSalesRepIds(
																	map.salesReps.map((rep) => rep.id),
																);
															}
														}}
													>
														Select All
													</button>
													<button
														className="deselect"
														onClick={() => {
															map.setAssignedSalesRepIds([]);
															map.setMyLeadsSalesRepIds([]);
															combinedSalesRepIds([]);
														}}
													>
														Deselect All
													</button>
												</div>
												<div
													style={{
														display: "flex",
														justifyContent: "flex-start",
														alignItems: "center",
														marginBottom: "1rem",
														width: "100%",
													}}
												>
													<div className="switch" style={{ gridGap: "1rem" }}>
														<div className="switch__2">
															<input
																onChange={(e) => {
																	if (combinedRepToggle === "AssignedTo") {
																		setCombinedRepToggle("UpdatedBy");
																		if (map.assignedLeadsEnabled === true) {
																			map.setAssignedRepToggle("UpdatedBy");
																		}
																		if (map.myLeadsEnabled === true) {
																			map.setMyLeadsRepToggle("UpdatedBy");
																		}
																	} else {
																		setCombinedRepToggle("AssignedTo");
																		if (map.assignedLeadsEnabled === true) {
																			map.setAssignedRepToggle("AssignedTo");
																		}
																		if (map.myLeadsEnabled === true) {
																			map.setMyLeadsRepToggle("AssignedTo");
																		}
																	}
																}}
																id="switch-3"
																type="checkbox"
																checked={combinedRepToggle !== "AssignedTo"}
															/>
															<label for="switch-3"></label>
														</div>
													</div>
													<p>
														{combinedRepToggle === "AssignedTo"
															? "Owned By"
															: "Updated By"}
													</p>
												</div>

												<div className="MapIconStats">
													{map.salesReps?.map((rep, index) => {
														if (
															rep.status !== "Inactive" &&
															combinedSalesOrgs.includes(rep.salesOrgId)
														)
															return (
																<div
																	style={{
																		// borderRadius: "10px",
																		width: "5rem",
																		height: "5rem",
																	}}
																	onClick={() => {
																		if (combinedSalesRepIds.includes(rep.id)) {
																			setCombinedSalesRepIds(
																				combinedSalesRepIds?.filter(
																					(id) => id !== rep.id,
																				),
																			);
																		} else {
																			setCombinedSalesRepIds([
																				...combinedSalesRepIds,
																				rep.id,
																			]);
																		}
																	}}
																	className={`MapIconStat ${
																		combinedSalesRepIds.includes(rep.id)
																			? "active"
																			: null
																	}`}
																	key={index}
																>
																	<h3>
																		{rep.profileImage ? (
																			<img
																				style={{ objectFit: "cover" }}
																				src={rep.profileImage?.url}
																				alt="ProfileImage"
																			/>
																		) : (
																			<img
																				style={{ objectFit: "cover" }}
																				src={greyUser}
																				alt="ProfileImage"
																			/>
																		)}
																	</h3>
																	<p
																		style={{
																			textAlign: "center",
																			fontSize: "0.6rem",
																		}}
																	>
																		{rep.firstName + " " + rep.lastName}
																	</p>
																</div>
															);
													})}
												</div>
												{user.userType === "SuperAdmin" && (
													<div
														style={{
															display: "flex",
															justifyContent: "flex-start",
															alignItems: "center",
															marginBottom: "1rem",
															width: "100%",
														}}
													>
														<div className="switch" style={{ gridGap: "1rem" }}>
															<div className="switch__2">
																<input
																	onChange={(e) => {
																		if (map.showDeactivatedAccounts) {
																			map.setShowDeactivatedAccounts(false);
																		} else {
																			map.setShowDeactivatedAccounts(true);
																		}
																	}}
																	id="switch-10"
																	type="checkbox"
																	checked={map.showDeactivatedAccounts}
																/>
																<label for="switch-10"></label>
															</div>
														</div>
														<p>Show Deactivated Accounts</p>
													</div>
												)}
												<div className="MapIconStats">
													{map.showDeactivatedAccounts &&
														map.salesReps?.map((rep, index) => {
															if (
																rep.status === "Inactive" &&
																combinedSalesOrgs.includes(rep.salesOrgId)
															)
																return (
																	<div
																		style={{
																			// borderRadius: "10px",
																			width: "5rem",
																			height: "5rem",
																		}}
																		onClick={() => {
																			if (
																				combinedSalesRepIds.includes(rep.id)
																			) {
																				setCombinedSalesRepIds(
																					combinedSalesRepIds?.filter(
																						(id) => id !== rep.id,
																					),
																				);
																			} else {
																				setCombinedSalesRepIds([
																					...combinedSalesRepIds,
																					rep.id,
																				]);
																			}
																		}}
																		className={`MapIconStat ${
																			combinedSalesRepIds.includes(rep.id)
																				? "active"
																				: null
																		}`}
																		key={index}
																	>
																		<h3>
																			{rep.profileImage ? (
																				<img
																					style={{ objectFit: "cover" }}
																					src={rep.profileImage?.url}
																					alt="ProfileImage"
																				/>
																			) : (
																				<img
																					style={{ objectFit: "cover" }}
																					src={greyUser}
																					alt="ProfileImage"
																				/>
																			)}
																		</h3>
																		<p
																			style={{
																				textAlign: "center",
																				fontSize: "0.6rem",
																			}}
																		>
																			{rep.firstName + " " + rep.lastName}
																		</p>
																	</div>
																);
														})}
												</div>
											</>
										)}
										<h1 className="lead_type_title">Lead Status</h1>
										<div className="select_deselect">
											<button
												className="select"
												onClick={() => {
													setCombinedMapIcons(
														map.mapIcons.map((icon) => icon.id),
													);
													if (map.assignedLeadsEnabled === true) {
														setAssignedMapIcons(
															map.mapIcons.map((icon) => icon.id),
														);
													}
													if (map.unassignedLeadsEnabled === true) {
														setUnassignedMapIcons(
															map.mapIcons.map((icon) => icon.id),
														);
													}
													if (map.myLeadsEnabled === true) {
														setMyLeadsMapIcons(
															map.mapIcons.map((icon) => icon.id),
														);
													}
												}}
											>
												Select All
											</button>
											<button
												className="deselect"
												onClick={() => {
													setAssignedMapIcons([]);
													setUnassignedMapIcons([]);
													setMyLeadsMapIcons([]);
													setCombinedMapIcons([]);
												}}
											>
												Deselect All
											</button>
										</div>
										<div
											style={{
												display: "flex",
												justifyContent: "flex-start",
												alignItems: "center",
												marginBottom: "1rem",
												width: "100%",
											}}
										>
											<div className="switch" style={{ gridGap: "1rem" }}>
												<div className="switch__2">
													<input
														onChange={(e) => {
															if (map.mapIconToggle === "CurrentMapIcon") {
																map.setMapIconToggle("OnceWas");
															} else {
																map.setMapIconToggle("CurrentMapIcon");
															}
														}}
														id="switch-5"
														type="checkbox"
														checked={map.mapIconToggle !== "CurrentMapIcon"}
													/>
													<label for="switch-5"></label>
												</div>
											</div>
											<p>
												{map.mapIconToggle === "CurrentMapIcon"
													? "Current Map Icon"
													: "Past Map Icon"}
											</p>
										</div>
										<div className="MapIconStats">
											{map.mapIcons
												?.filter((icon) => icon.iconType === null)
												?.map((icon, index) => {
													return (
														<div
															key={index}
															onClick={() => {
																if (combinedMapIcons.includes(icon.id)) {
																	setCombinedMapIcons(
																		combinedMapIcons?.filter(
																			(id) => id !== icon.id,
																		),
																	);
																} else {
																	setCombinedMapIcons([
																		...combinedMapIcons,
																		icon.id,
																	]);
																}

																if (map.assignedLeadsEnabled === true) {
																	if (assignedMapIcons.includes(icon.id)) {
																		setAssignedMapIcons(
																			assignedMapIcons?.filter(
																				(id) => id !== icon.id,
																			),
																		);
																	} else {
																		setAssignedMapIcons([
																			...assignedMapIcons,
																			icon.id,
																		]);
																	}
																}
																if (map.unassignedLeadsEnabled === true) {
																	if (unassignedMapIcons.includes(icon.id)) {
																		setUnassignedMapIcons(
																			unassignedMapIcons?.filter(
																				(id) => id !== icon.id,
																			),
																		);
																	} else {
																		setUnassignedMapIcons([
																			...unassignedMapIcons,
																			icon.id,
																		]);
																	}
																}
																if (map.myLeadsEnabled === true) {
																	if (myLeadsMapIcons.includes(icon.id)) {
																		setMyLeadsMapIcons(
																			myLeadsMapIcons?.filter(
																				(id) => id !== icon.id,
																			),
																		);
																	} else {
																		setMyLeadsMapIcons([
																			...myLeadsMapIcons,
																			icon.id,
																		]);
																	}
																}
															}}
															className={`MapIconStat  ${
																combinedMapIcons?.includes(icon.id)
																	? "active"
																	: null
															}`}
														>
															<h3>
																<img
																	src={"data:image/png;base64," + icon.image}
																	alt="Map Icon"
																/>
															</h3>
															<p>{icon.abbreviation}</p>
														</div>
													);
												})}
										</div>
									</div>
								</AccordionDetails>
							</Accordion>
							<h1 className="action_title">Quick Search</h1>
							<div className="action_buttons">
								<button
									className={`action_button ${
										combinedAcountStatus === "" ? "active" : null
									}`}
									onClick={() => {
										setCombinedAcountStatus("");
										if (map.assignedLeadsEnabled === true) {
											map.setAssignedAcountStatus("");
										}
										if (map.unassignedLeadsEnabled === true) {
											map.setUnassignedAcountStatus("");
										}
										if (map.myLeadsEnabled === true) {
											map.setMyLeadsAcountStatus("");
										}
									}}
								>
									All
								</button>
								<button
									className={`action_button ${
										assignedAcountStatus === "Sold" ? "active" : null
									}`}
									onClick={() => {
										setCombinedAcountStatus("Sold");
										if (map.assignedLeadsEnabled === true) {
											map.setAssignedAcountStatus("Sold");
										}
										if (map.unassignedLeadsEnabled === true) {
											map.setUnassignedAcountStatus("Sold");
										}
										if (map.myLeadsEnabled === true) {
											map.setMyLeadsAcountStatus("Sold");
										}
									}}
								>
									Sold
								</button>
								<button
									className={`action_button ${
										combinedAcountStatus === "Completed" ? "active" : null
									}`}
									onClick={() => {
										setCombinedAcountStatus("Completed");
										if (map.assignedLeadsEnabled === true) {
											map.setAssignedAcountStatus("Completed");
										}
										if (map.unassignedLeadsEnabled === true) {
											map.setUnassignedAcountStatus("Completed");
										}
										if (map.myLeadsEnabled === true) {
											map.setMyLeadsAcountStatus("Completed");
										}
									}}
								>
									Completed
								</button>
								<button
									className={`action_button ${
										combinedAcountStatus === "Canceled" ? "active" : null
									}`}
									onClick={() => {
										setCombinedAcountStatus("Canceled");
										if (map.assignedLeadsEnabled === true) {
											map.setAssignedAcountStatus("Canceled");
										}
										if (map.unassignedLeadsEnabled === true) {
											map.setUnassignedAcountStatus("Canceled");
										}
										if (map.myLeadsEnabled === true) {
											map.setMyLeadsAcountStatus("Canceled");
										}
									}}
								>
									Canceled
								</button>
								<button
									className={`action_button ${
										combinedAcountStatus === "Scheduled" ? "active" : null
									}`}
									onClick={() => {
										if (
											combinedAcountStatus !== "Scheduled" &&
											combinedQuickDate !== "Today"
										) {
											setCombinedQuickDate("");
											setCombinedUpdatedFrom("");
											setCombinedUpdatedTo("");
											if (map.assignedLeadsEnabled === true) {
												map.setAssignedQuickDate("");
												map.setAssignedUpdatedFrom("");
												map.setAssignedUpdatedTo("");
											}
											if (map.unassignedLeadsEnabled === true) {
												map.setUnassignedQuickDate("");
												map.setUnassignedUpdatedFrom("");
												map.setUnassignedUpdatedTo("");
											}
											if (map.myLeadsEnabled === true) {
												map.setMyLeadsQuickDate("");
												map.setMyLeadsUpdatedFrom("");
												map.setMyLeadsUpdatedTo("");
											}
										}
										setCombinedAcountStatus("Scheduled");
										if (map.assignedLeadsEnabled === true) {
											map.setAssignedAcountStatus("Scheduled");
										}
										if (map.unassignedLeadsEnabled === true) {
											map.setUnassignedAcountStatus("Scheduled");
										}
										if (map.myLeadsEnabled === true) {
											map.setMyLeadsAcountStatus("Scheduled");
										}
									}}
								>
									Installs Pending
								</button>
								<button
									className={`action_button ${
										combinedAcountStatus === "CancelsPending" ? "active" : null
									}`}
									onClick={() => {
										setCombinedAcountStatus("CancelsPending");
										if (map.assignedLeadsEnabled === true) {
											map.setAssignedAcountStatus("CancelsPending");
										}
										if (map.unassignedLeadsEnabled === true) {
											map.setUnassignedAcountStatus("CancelsPending");
										}
										if (map.myLeadsEnabled === true) {
											map.setMyLeadsAcountStatus("CancelsPending");
										}
									}}
								>
									Cancels Pending
								</button>
							</div>
							<div className="action_date InputsDiv">
								<QuickDate
									future={combinedAcountStatus === "Scheduled"}
									selectQuickDate={combinedQuickDate}
									setQuickDateValue={(value) => {
										setCombinedQuickDate(value);
										if (map.assignedLeadsEnabled === true) {
											map.setAssignedQuickDate(value);
										}
										if (map.unassignedLeadsEnabled === true) {
											map.setUnassignedQuickDate(value);
										}
										if (map.myLeadsEnabled === true) {
											map.setMyLeadsQuickDate(value);
										}
									}}
									setFrom={(value) => {
										setCombinedUpdatedFrom(value);
										if (map.assignedLeadsEnabled === true) {
											map.setAssignedUpdatedFrom(value);
										}
										if (map.unassignedLeadsEnabled === true) {
											map.setUnassignedUpdatedFrom(value);
										}
										if (map.myLeadsEnabled === true) {
											map.setMyLeadsUpdatedFrom(value);
										}
									}}
									setTo={(value) => {
										setCombinedUpdatedTo(value);
										if (map.assignedLeadsEnabled === true) {
											map.setAssignedUpdatedTo(value);
										}
										if (map.unassignedLeadsEnabled === true) {
											map.setUnassignedUpdatedTo(value);
										}
										if (map.myLeadsEnabled === true) {
											map.setMyLeadsUpdatedTo(value);
										}
									}}
									from={combinedUpdatedFrom}
									to={combinedUpdatedTo}
								/>
							</div>
						</div>
					</>
				) : (
					<>
						{(user.userType === "SuperAdmin" ||
							user.userType === "SalesOrgAdmin") && (
							<>
								<div
									style={{ marginBottom: "1rem" }}
									className="search_filter_container"
								>
									<button
										disabled={assignedColor() === "#E6E6E6"}
										style={{
											backgroundColor: assignedColor(),
										}}
										onClick={() => {
											resetMyLeadFilters();
										}}
										className="reset_all_filters"
									>
										Reset Filters
									</button>
									<Accordion
										sx={{
											boxShadow: "none",
											width: "100%",
										}}
									>
										<AccordionSummary
											sx={{
												display: "flex",
												justifyContent: "space-between",
												alignItems: "center",
											}}
										>
											<Typography> My Leads</Typography>
											<div className="switch">
												<div className="switch__2">
													<input
														onChange={(e) => {
															map.setMyLeadsEnabled(e.target.checked);
															if (e.target.checked) {
																map.setAssignedLeadsEnabled(false);
															}
															console.log(e.target.checked);
														}}
														id="switch-11"
														type="checkbox"
														checked={map.myLeadsEnabled}
													/>
													<label for="switch-11"></label>
												</div>
											</div>
										</AccordionSummary>
										<AccordionDetails>
											<div className="InputsDiv">
												<div className="InputDiv">
													<label htmlFor="assignedConvertedToCustomer">
														Lead Type
													</label>
													<select
														className="p-2 border-2 outline-none rounded-lg"
														name="assignedConvertedToCustomer"
														value={myLeadsConvertedToCustomer ?? "null"}
														onChange={(e) => {
															const value = e.target.value;
															setMyLeadsConvertedToCustomer(
																value !== "0"
																	? value === "true"
																		? true
																		: value === "false"
																		? false
																		: null
																	: null,
															);
														}}
													>
														<option value="null">All</option>
														<option value="true">Customer</option>
														<option value="false">Hot Lead</option>
													</select>
												</div>
												<div className="InputDiv">
													<label>Segment</label>
													<AsyncSelect
														isMulti
														cacheOptions
														defaultOptions={segments.map((segment) => ({
															label: segment,
															value: segment,
														}))}
														loadOptions={(inputValue, callback) => {
															// Simple filter for demonstration; replace with API call if needed
															const filtered = segments
																.filter((segment) =>
																	segment
																		.toLowerCase()
																		.includes(inputValue.toLowerCase()),
																)
																.map((segment) => ({
																	label: segment,
																	value: segment,
																}));
															callback(filtered);
														}}
														onChange={(selectedOptions) => {
															// selectedOptions is an array of { label, value }
															setMyLeadsSegment(
																selectedOptions
																	? selectedOptions.map((opt) => opt.value)
																	: [],
															);
														}}
														classNamePrefix="react-select"
														placeholder="Select Segment(s)"
														value={
															myLeadsSegment && Array.isArray(myLeadsSegment)
																? myLeadsSegment.map((seg) => ({
																		label: seg,
																		value: seg,
																  }))
																: []
														}
													/>
												</div>
												{myLeadsConvertedToCustomer !== false && (
													<div className="InputDiv">
														<label htmlFor="accountStatus">
															Account Status
														</label>
														<select
															className="p-2 border-2 outline-none rounded-lg"
															name="accountStatus"
															value={myLeadsAcountStatus}
															onChange={(e) => {
																e.target.value !== "0"
																	? setMyLeadsAcountStatus(e.target.value)
																	: setMyLeadsAcountStatus(null);
															}}
														>
															<option value="0">All</option>
															<option value="Sold">Sold</option>
															<option value="VerifiedSold">
																Verified Sold
															</option>
															<option value="PendingCancels">
																Pending Cancels
															</option>
															<option value="PendinReshcedules">
																Pending Reschedules
															</option>
															<option value="Missing">Missing</option>
															<option value={"Completed"}>Completed</option>
															<option value="Canceled">Canceled</option>
															<option value={"Scheduled"}>
																Pending Installs
															</option>
														</select>
													</div>
												)}
												{myLeadsConvertedToCustomer === false && (
													<div className="InputDiv">
														<label>Sold</label>
														<div
															style={{
																gridColumn: "span 1",
																width: "100%",
															}}
															className="switch"
														>
															<div className="switch__2">
																<input
																	onChange={(e) => {
																		map.setMyLeadsProspectSold(
																			e.target.checked,
																		);
																	}}
																	id="switch-5"
																	type="checkbox"
																	checked={map.MyLeadsProspectSold}
																/>
																<label for="switch-5"></label>
															</div>
														</div>
													</div>
												)}

												<div className="InputDiv">
													<label htmlFor="DateType">Date Type</label>
													<select
														value={myLeadsDateType}
														onChange={(e) => {
															setMyLeadsDateType(e.target.value);
														}}
													>
														<option value={"LastUpdated"}>Last Updated</option>
														<option value={"DateSold"}>Date Sold</option>
														<option value={"InstallDate"}>Install Date</option>
														<option value={"AppointmentDate"}>
															Appointment Date
														</option>
														<option value={"CreatedAt"}>Created At</option>
													</select>
												</div>

												<SelectionMenu
													tags={tags}
													onChange={(selected) => setMySelectedTags(selected)}
													selectedItems={mySelectedTags}
													setSelectedItems={setMySelectedTags}
													searchCriteria={searchCriteria}
													setSearchCriteria={setSearchCriteria}
												/>

												<div className="InputDiv">
													<label hmltFor="include_invalid">
														Include Invalids
													</label>
													<div
														style={{
															gridColumn: "span 1",
															width: "100%",
														}}
														className="switch"
													>
														<div className="switch__2">
															<input
																onChange={(e) => {
																	map.setIncludeInvalid(e.target.checked);
																}}
																id="switch-20"
																type="checkbox"
																checked={map.includeInvalid}
															/>
															<label for="switch-20"></label>
														</div>
													</div>
												</div>
												<div className="InputDiv">
													<label hmltFor="include_paid">Include Paid</label>
													<div
														style={{
															gridColumn: "span 1",
															width: "100%",
														}}
														className="switch"
													>
														<div className="switch__2">
															<input
																onChange={(e) => {
																	map.setIncludePaid(e.target.checked);
																}}
																id="include_paid"
																type="checkbox"
																checked={map.includePaid}
															/>
															<label for="include_paid"></label>
														</div>
													</div>
												</div>

												<QuickDate
													future={myLeadsAcountStatus === "Scheduled"}
													selectQuickDate={map.myLeadsQuickDate}
													setQuickDateValue={map.setMyLeadsQuickDate}
													setFrom={map.setMyLeadsUpdatedFrom}
													setTo={map.setMyLeadsUpdatedTo}
												/>
												<div className="company_selector">
													<FiberCompanySelector
														companyObject={map.myLeadsCompanyWithName}
														setCompanyObject={map.setMyLeadsCompanyWithName}
														multiple={true}
														setUser={map.setMyLeadsFiberCompanyIds}
														placeholder="Select Fiber Company"
													/>
												</div>

												<h1 className="lead_type_title">Lead Status</h1>
												<div className="select_deselect">
													<button
														className="select"
														onClick={() => {
															setMyLeadsMapIcons(
																map.mapIcons.map((icon) => icon.id),
															);
														}}
													>
														Select All
													</button>
													<button
														className="deselect"
														onClick={() => {
															setMyLeadsMapIcons([]);
														}}
													>
														Deselect All
													</button>
												</div>
												<div
													style={{
														display: "flex",
														justifyContent: "flex-start",
														alignItems: "center",
														marginBottom: "1rem",
														width: "100%",
													}}
												>
													<div className="switch" style={{ gridGap: "1rem" }}>
														<div className="switch__2">
															<input
																onChange={(e) => {
																	if (map.mapIconToggle === "CurrentMapIcon") {
																		map.setMapIconToggle("OnceWas");
																	} else {
																		map.setMapIconToggle("CurrentMapIcon");
																	}
																}}
																id="switch-5"
																type="checkbox"
																checked={map.mapIconToggle !== "CurrentMapIcon"}
															/>
															<label for="switch-5"></label>
														</div>
													</div>
													<p>
														{map.mapIconToggle === "CurrentMapIcon"
															? "Current Map Icon"
															: "Past Map Icon"}
													</p>
												</div>
												<div className="MapIconStats">
													{map.mapIcons
														?.filter((icon) => icon.iconType === null)
														?.map((icon, index) => {
															return (
																<div
																	key={index}
																	onClick={() => {
																		if (myLeadsMapIcons.includes(icon.id)) {
																			setMyLeadsMapIcons(
																				myLeadsMapIcons?.filter(
																					(id) => id !== icon.id,
																				),
																			);
																		} else {
																			setMyLeadsMapIcons([
																				...myLeadsMapIcons,
																				icon.id,
																			]);
																		}
																	}}
																	className={`MapIconStat  ${
																		myLeadsMapIcons?.includes(icon.id)
																			? "active"
																			: null
																	}`}
																>
																	<h3>
																		<img
																			src={
																				"data:image/png;base64," + icon.image
																			}
																			alt="Map Icon"
																		/>
																	</h3>
																	<p>{icon.abbreviation}</p>
																</div>
															);
														})}
												</div>
											</div>
										</AccordionDetails>
									</Accordion>
									<h1 className="action_title">Quick Search</h1>
									<div className="action_buttons">
										<button
											className={`action_button ${
												myLeadsAcountStatus === "" ? "active" : null
											}`}
											onClick={() => {
												setMyLeadsAcountStatus("");
											}}
										>
											All
										</button>
										<button
											className={`action_button ${
												myLeadsAcountStatus === "Sold" ? "active" : null
											}`}
											onClick={() => {
												setMyLeadsAcountStatus("Sold");
											}}
										>
											Sold
										</button>
										<button
											className={`action_button ${
												myLeadsAcountStatus === "Completed" ? "active" : null
											}`}
											onClick={() => {
												setMyLeadsAcountStatus("Completed");
											}}
										>
											Completed
										</button>
										<button
											className={`action_button ${
												myLeadsAcountStatus === "Canceled" ? "active" : null
											}`}
											onClick={() => {
												setMyLeadsAcountStatus("Canceled");
											}}
										>
											Canceled
										</button>
										<button
											className={`action_button ${
												myLeadsAcountStatus === "Scheduled" ? "active" : null
											}`}
											onClick={() => {
												if (
													myLeadsAcountStatus !== "Scheduled" &&
													map.myLeadsQuickDate !== "Today"
												) {
													map.setMyLeadsQuickDate("");
													map.setMyLeadsUpdatedFrom("");
													map.setMyLeadsUpdatedTo("");
												}
												setMyLeadsAcountStatus("Scheduled");
											}}
										>
											Installs Pending
										</button>
										<button
											className={`action_button ${
												myLeadsAcountStatus === "CancelsPending"
													? "active"
													: null
											}`}
											onClick={() => {
												setMyLeadsAcountStatus("CancelsPending");
											}}
										>
											Cancels Pending
										</button>
									</div>
									<div className="action_date InputsDiv">
										<QuickDate
											future={myLeadsAcountStatus === "Scheduled"}
											selectQuickDate={map.myLeadsQuickDate}
											setQuickDateValue={map.setMyLeadsQuickDate}
											setFrom={map.setMyLeadsUpdatedFrom}
											setTo={map.setMyLeadsUpdatedTo}
											from={map.myLeadsUpdatedFrom}
											to={map.myLeadsUpdatedTo}
										/>
									</div>
								</div>
							</>
						)}
						{user.userType === "SalesRep" ? (
							<div
								style={{ marginBottom: "1rem" }}
								className="search_filter_container"
							>
								<button
									disabled={assignedColor() === "#E6E6E6"}
									style={{
										backgroundColor: assignedColor(),
									}}
									onClick={() => {
										resetMyLeadFilters();
									}}
									className="reset_all_filters"
								>
									Reset Filters
								</button>
								<Accordion
									sx={{
										boxShadow: "none",
										width: "100%",
									}}
								>
									<AccordionSummary
										sx={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
										}}
									>
										<Typography> My Leads</Typography>
										<div className="switch">
											<div className="switch__2">
												<input
													onChange={(e) => {
														map.setMyLeadsEnabled(e.target.checked);
														console.log(e.target.checked);
													}}
													id="switch-11"
													type="checkbox"
													checked={map.myLeadsEnabled}
												/>
												<label for="switch-11"></label>
											</div>
										</div>
									</AccordionSummary>
									<AccordionDetails>
										<div className="InputsDiv">
											<div className="InputDiv">
												<label htmlFor="assignedConvertedToCustomer">
													Lead Type
												</label>
												<select
													className="p-2 border-2 outline-none rounded-lg"
													name="assignedConvertedToCustomer"
													value={myLeadsConvertedToCustomer ?? "null"}
													onChange={(e) => {
														const value = e.target.value;
														setMyLeadsConvertedToCustomer(
															value !== "0"
																? value === "true"
																	? true
																	: value === "false"
																	? false
																	: null
																: null,
														);
													}}
												>
													<option value="null">All</option>
													<option value="true">Customer</option>
													<option value="false">Hot Lead</option>
												</select>
											</div>
											<div className="InputDiv">
												<label>Segment</label>
												<AsyncSelect
													isMulti
													cacheOptions
													defaultOptions={segments.map((segment) => ({
														label: segment,
														value: segment,
													}))}
													loadOptions={(inputValue, callback) => {
														// Simple filter for demonstration; replace with API call if needed
														const filtered = segments
															.filter((segment) =>
																segment
																	.toLowerCase()
																	.includes(inputValue.toLowerCase()),
															)
															.map((segment) => ({
																label: segment,
																value: segment,
															}));
														callback(filtered);
													}}
													onChange={(selectedOptions) => {
														// selectedOptions is an array of { label, value }
														setMyLeadsSegment(
															selectedOptions
																? selectedOptions.map((opt) => opt.value)
																: [],
														);
													}}
													classNamePrefix="react-select"
													placeholder="Select Segment(s)"
													value={
														myLeadsSegment && Array.isArray(myLeadsSegment)
															? myLeadsSegment.map((seg) => ({
																	label: seg,
																	value: seg,
															  }))
															: []
													}
												/>
											</div>

											{myLeadsConvertedToCustomer !== false && (
												<div className="InputDiv">
													<label htmlFor="accountStatus">Account Status</label>
													<select
														className="p-2 border-2 outline-none rounded-lg"
														name="accountStatus"
														value={myLeadsAcountStatus}
														onChange={(e) => {
															e.target.value !== "0"
																? setMyLeadsAcountStatus(e.target.value)
																: setMyLeadsAcountStatus(null);
														}}
													>
														<option value="0">All</option>
														<option value="Sold">Sold</option>
														<option value="VerifiedSold">Verified Sold</option>
														<option value="PendingCancels">
															Pending Cancels
														</option>
														<option value="PendinReshcedules">
															Pending Reschedules
														</option>
														<option value="Missing">Missing</option>
														<option value={"Completed"}>Completed</option>
														<option value="Canceled">Canceled</option>
														<option value={"Scheduled"}>
															Pending Installs
														</option>
													</select>
												</div>
											)}
											{myLeadsConvertedToCustomer === false && (
												<div className="InputDiv">
													<label>Sold</label>
													<div
														style={{
															gridColumn: "span 1",
															width: "100%",
														}}
														className="switch"
													>
														<div className="switch__2">
															<input
																onChange={(e) => {
																	map.setMyLeadsProspectSold(e.target.checked);
																}}
																id="switch-5"
																type="checkbox"
																checked={map.MyLeadsProspectSold}
															/>
															<label for="switch-5"></label>
														</div>
													</div>
												</div>
											)}

											<div className="InputDiv">
												<label htmlFor="DateType">Date Type</label>
												<select
													value={myLeadsDateType}
													onChange={(e) => {
														setMyLeadsDateType(e.target.value);
													}}
												>
													<option value={"LastUpdated"}>Last Updated</option>
													<option value={"DateSold"}>Date Sold</option>
													<option value={"InstallDate"}>Install Date</option>
													<option value={"AppointmentDate"}>
														Appointment Date
													</option>
													<option value={"CreatedAt"}>Created At</option>
												</select>
											</div>

											<SelectionMenu
												tags={tags}
												onChange={(selected) => setMySelectedTags(selected)}
												selectedItems={mySelectedTags}
												setSelectedItems={setMySelectedTags}
												searchCriteria={searchCriteria}
												setSearchCriteria={setSearchCriteria}
											/>

											<div className="InputDiv">
												<label hmltFor="include_invalid">
													Include Invalids
												</label>
												<div
													style={{
														gridColumn: "span 1",
														width: "100%",
													}}
													className="switch"
												>
													<div className="switch__2">
														<input
															onChange={(e) => {
																map.setIncludeInvalid(e.target.checked);
															}}
															id="switch-20"
															type="checkbox"
															checked={map.includeInvalid}
														/>
														<label for="switch-20"></label>
													</div>
												</div>
											</div>
											<div className="InputDiv">
												<label hmltFor="include_paid">Include Paid</label>
												<div
													style={{
														gridColumn: "span 1",
														width: "100%",
													}}
													className="switch"
												>
													<div className="switch__2">
														<input
															onChange={(e) => {
																map.setIncludePaid(e.target.checked);
															}}
															id="include_paid"
															type="checkbox"
															checked={map.includePaid}
														/>
														<label for="include_paid"></label>
													</div>
												</div>
											</div>

											<QuickDate
												future={myLeadsAcountStatus === "Scheduled"}
												selectQuickDate={map.myLeadsQuickDate}
												setQuickDateValue={map.setMyLeadsQuickDate}
												setFrom={map.setMyLeadsUpdatedFrom}
												setTo={map.setMyLeadsUpdatedTo}
											/>
											<div className="company_selector">
												<FiberCompanySelector
													companyObject={map.myLeadsCompanyWithName}
													setCompanyObject={map.setMyLeadsCompanyWithName}
													multiple={true}
													setUser={map.setMyLeadsFiberCompanyIds}
													placeholder="Select Fiber Company"
												/>
											</div>

											<h1 className="lead_type_title">Lead Status</h1>
											<div className="select_deselect">
												<button
													className="select"
													onClick={() => {
														setMyLeadsMapIcons(
															map.mapIcons.map((icon) => icon.id),
														);
													}}
												>
													Select All
												</button>
												<button
													className="deselect"
													onClick={() => {
														setMyLeadsMapIcons([]);
													}}
												>
													Deselect All
												</button>
											</div>
											<div
												style={{
													display: "flex",
													justifyContent: "flex-start",
													alignItems: "center",
													marginBottom: "1rem",
													width: "100%",
												}}
											>
												<div className="switch" style={{ gridGap: "1rem" }}>
													<div className="switch__2">
														<input
															onChange={(e) => {
																if (map.mapIconToggle === "CurrentMapIcon") {
																	map.setMapIconToggle("OnceWas");
																} else {
																	map.setMapIconToggle("CurrentMapIcon");
																}
															}}
															id="switch-5"
															type="checkbox"
															checked={map.mapIconToggle !== "CurrentMapIcon"}
														/>
														<label for="switch-5"></label>
													</div>
												</div>
												<p>
													{map.mapIconToggle === "CurrentMapIcon"
														? "Current Map Icon"
														: "Past Map Icon"}
												</p>
											</div>
											<div className="MapIconStats">
												{map.mapIcons
													?.filter((icon) => icon.iconType === null)
													?.map((icon, index) => {
														return (
															<div
																key={index}
																onClick={() => {
																	if (myLeadsMapIcons.includes(icon.id)) {
																		setMyLeadsMapIcons(
																			myLeadsMapIcons?.filter(
																				(id) => id !== icon.id,
																			),
																		);
																	} else {
																		setMyLeadsMapIcons([
																			...myLeadsMapIcons,
																			icon.id,
																		]);
																	}
																}}
																className={`MapIconStat  ${
																	myLeadsMapIcons?.includes(icon.id)
																		? "active"
																		: null
																}`}
															>
																<h3>
																	<img
																		src={"data:image/png;base64," + icon.image}
																		alt="Map Icon"
																	/>
																</h3>
																<p>{icon.abbreviation}</p>
															</div>
														);
													})}
											</div>
										</div>
									</AccordionDetails>
								</Accordion>
								<h1 className="action_title">Quick Search</h1>
								<div className="action_buttons">
									<button
										className={`action_button ${
											myLeadsAcountStatus === "" ? "active" : null
										}`}
										onClick={() => {
											setMyLeadsAcountStatus("");
										}}
									>
										All
									</button>
									<button
										className={`action_button ${
											myLeadsAcountStatus === "Sold" ? "active" : null
										}`}
										onClick={() => {
											setMyLeadsAcountStatus("Sold");
										}}
									>
										Sold
									</button>
									<button
										className={`action_button ${
											myLeadsAcountStatus === "Completed" ? "active" : null
										}`}
										onClick={() => {
											setMyLeadsAcountStatus("Completed");
										}}
									>
										Completed
									</button>
									<button
										className={`action_button ${
											myLeadsAcountStatus === "Canceled" ? "active" : null
										}`}
										onClick={() => {
											setMyLeadsAcountStatus("Canceled");
										}}
									>
										Canceled
									</button>
									<button
										className={`action_button ${
											myLeadsAcountStatus === "Scheduled" ? "active" : null
										}`}
										onClick={() => {
											if (
												myLeadsAcountStatus !== "Scheduled" &&
												map.myLeadsQuickDate !== "Today"
											) {
												map.setMyLeadsQuickDate("");
												map.setMyLeadsUpdatedFrom("");
												map.setMyLeadsUpdatedTo("");
											}
											setMyLeadsAcountStatus("Scheduled");
										}}
									>
										Installs Pending
									</button>
									<button
										className={`action_button ${
											myLeadsAcountStatus === "CancelsPending" ? "active" : null
										}`}
										onClick={() => {
											setMyLeadsAcountStatus("CancelsPending");
										}}
									>
										Cancels Pending
									</button>
								</div>
								<div className="action_date InputsDiv">
									<QuickDate
										future={myLeadsAcountStatus === "Scheduled"}
										selectQuickDate={map.myLeadsQuickDate}
										setQuickDateValue={map.setMyLeadsQuickDate}
										setFrom={map.setMyLeadsUpdatedFrom}
										setTo={map.setMyLeadsUpdatedTo}
										from={map.myLeadsUpdatedFrom}
										to={map.myLeadsUpdatedTo}
									/>
								</div>
							</div>
						) : (
							<div
								style={{ marginBottom: "1rem" }}
								className="search_filter_container"
							>
								<button
									disabled={assignedColor() === "#E6E6E6"}
									style={{
										backgroundColor: assignedColor(),
									}}
									onClick={() => {
										resetAssignedFilters();
									}}
									className="reset_all_filters"
								>
									Reset Filters
								</button>
								<Accordion
									sx={{
										boxShadow: "none",
										width: "100%",
									}}
								>
									<AccordionSummary
										sx={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
										}}
									>
										<Typography>
											{" "}
											{user.userType === "SalesRep"
												? "My Leads"
												: "Assigned Leads"}{" "}
										</Typography>
										<div className="switch">
											<div className="switch__2">
												<input
													onChange={(e) => {
														map.setAssignedLeadsEnabled(e.target.checked);
														if (e.target.checked) {
															map.setMyLeadsEnabled(false);
														}
													}}
													id="switch-2"
													type="checkbox"
													checked={map.assignedLeadsEnabled}
												/>
												<label for="switch-2"></label>
											</div>
										</div>
									</AccordionSummary>
									<AccordionDetails>
										<div className="InputsDiv">
											<div className="InputDiv">
												<label htmlFor="assignedConvertedToCustomer">
													Lead Type
												</label>
												<select
													className="p-2 border-2 outline-none rounded-lg"
													name="assignedConvertedToCustomer"
													value={assignedConvertedToCustomer ?? "null"}
													onChange={(e) => {
														const value = e.target.value;
														setAssignedConvertedToCustomer(
															value !== "0"
																? value === "true"
																	? true
																	: value === "false"
																	? false
																	: null
																: null,
														);
													}}
												>
													<option value="null">All</option>
													<option value="true">Customer</option>
													<option value="false">Hot Lead</option>
												</select>
											</div>

											<div className="InputDiv">
												<label>Segment</label>
												<AsyncSelect
													isMulti
													cacheOptions
													defaultOptions={segments.map((segment) => ({
														label: segment,
														value: segment,
													}))}
													loadOptions={(inputValue, callback) => {
														// Simple filter for demonstration; replace with API call if needed
														const filtered = segments
															.filter((segment) =>
																segment
																	.toLowerCase()
																	.includes(inputValue.toLowerCase()),
															)
															.map((segment) => ({
																label: segment,
																value: segment,
															}));
														callback(filtered);
													}}
													onChange={(selectedOptions) => {
														// selectedOptions is an array of { label, value }
														setAssignedSegment(
															selectedOptions
																? selectedOptions.map((opt) => opt.value)
																: [],
														);
													}}
													classNamePrefix="react-select"
													placeholder="Select Segment(s)"
													value={
														assignedSegment && Array.isArray(assignedSegment)
															? assignedSegment.map((seg) => ({
																	label: seg,
																	value: seg,
															  }))
															: []
													}
												/>
											</div>
											{assignedConvertedToCustomer !== false && (
												<div className="InputDiv">
													<label htmlFor="accountStatus">Account Status</label>
													<select
														className="p-2 border-2 outline-none rounded-lg"
														name="accountStatus"
														value={assignedAcountStatus}
														onChange={(e) => {
															e.target.value !== "0"
																? setAssignedAcountStatus(e.target.value)
																: setAssignedAcountStatus(null);
														}}
													>
														<option value="0">All</option>
														<option value="Sold">Sold</option>
														<option value="VerifiedSold">Verified Sold</option>
														<option value="PendingCancels">
															Pending Cancels
														</option>
														<option value="PendinReshcedules">
															Pending Reschedules
														</option>
														<option value="Missing">Missing</option>
														<option value={"Completed"}>Completed</option>
														<option value="Canceled">Canceled</option>
														<option value={"Scheduled"}>
															Pending Installs
														</option>
													</select>
												</div>
											)}
											{assignedConvertedToCustomer === false && (
												<div className="InputDiv">
													<label>Sold</label>
													<div
														style={{
															gridColumn: "span 1",
															width: "100%",
														}}
														className="switch"
													>
														<div className="switch__2">
															<input
																onChange={(e) => {
																	map.setAssignedProspectSold(e.target.checked);
																}}
																id="switch-5"
																type="checkbox"
																checked={map.assignedProspectSold}
															/>
															<label for="switch-5"></label>
														</div>
													</div>
												</div>
											)}

											<div className="InputDiv">
												<label htmlFor="DateType">Date Type</label>
												<select
													value={assignedDateType}
													onChange={(e) => {
														setAssignedDateType(e.target.value);
													}}
												>
													<option value={"LastUpdated"}>Last Updated</option>
													<option value={"DateSold"}>Date Sold</option>
													<option value={"InstallDate"}>Install Date</option>
													<option value={"AppointmentDate"}>
														Appointment Date
													</option>
													<option value={"CreatedAt"}>Created At</option>
													{/* <option value={"CancelRequestDate"}>Cancel Request Date</option> */}
												</select>
											</div>

											<SelectionMenu
												tags={tags}
												onChange={(selected) =>
													setAssignedSelectedTags(selected)
												}
												value={assignedSelectedTags}
												selectedItems={assignedSelectedTags}
												setSelectedItems={setAssignedSelectedTags}
												searchCriteria={searchCriteria}
												setSearchCriteria={setSearchCriteria}
											/>

											<div className="InputDiv">
												<label hmltFor="include_invalid">
													Include Invalids
												</label>
												<div
													style={{
														gridColumn: "span 1",
														width: "100%",
													}}
													className="switch"
												>
													<div className="switch__2">
														<input
															onChange={(e) => {
																map.setIncludeInvalid(e.target.checked);
															}}
															id="switch-20"
															type="checkbox"
															checked={map.includeInvalid}
														/>
														<label for="switch-20"></label>
													</div>
												</div>
											</div>
											<div className="InputDiv">
												<label hmltFor="include_paid">Include Paid</label>
												<div
													style={{
														gridColumn: "span 1",
														width: "100%",
													}}
													className="switch"
												>
													<div className="switch__2">
														<input
															onChange={(e) => {
																map.setIncludePaid(e.target.checked);
															}}
															id="include_paid"
															type="checkbox"
															checked={map.includePaid}
														/>
														<label for="include_paid"></label>
													</div>
												</div>
											</div>

											<QuickDate
												future={assignedAcountStatus === "Scheduled"}
												selectQuickDate={map.assignedQuickDate}
												setQuickDateValue={map.setAssignedQuickDate}
												setFrom={map.setAssignedUpdatedFrom}
												setTo={map.setAssignedUpdatedTo}
											/>
											<div className="company_selector">
												<FiberCompanySelector
													companyObject={map.assignedCompanyWithName}
													setCompanyObject={map.setAssignedCompanyWithName}
													multiple={true}
													setUser={map.setAssignedFiberCompanyIds}
													placeholder="Select Fiber Company"
												/>
											</div>
											{user.userType === "SuperAdmin" && (
												<>
													<h1 className="lead_type_title">Sales Orgs</h1>
													<div className="select_deselect">
														<button
															className="select"
															onClick={() => {
																map.setAssignedSalesOrgs(
																	map.salesOrg.map((org) => org.id),
																);
															}}
														>
															Select All
														</button>
														<button
															className="deselect"
															onClick={() => {
																map.setAssignedSalesOrgs([]);
															}}
														>
															Deselect All
														</button>
													</div>
													<div className="MapIconStats">
														{map.salesOrg?.map((org, index) => {
															return (
																<div
																	style={{
																		// borderRadius: "10px",
																		width: "5rem",
																		height: "5rem",
																	}}
																	onClick={() => {
																		if (
																			map.assignedSalesOrgs.includes(org.id)
																		) {
																			map.setAssignedSalesOrgs(
																				map.assignedSalesOrgs?.filter(
																					(id) => id !== org.id,
																				),
																			);
																		} else {
																			map.setAssignedSalesOrgs([
																				...map.assignedSalesOrgs,
																				org.id,
																			]);
																		}
																	}}
																	className={`MapIconStat ${
																		map.assignedSalesOrgs.includes(org.id)
																			? "active"
																			: null
																	}`}
																	key={index}
																>
																	<h3>
																		{org.icon ? (
																			<img
																				src={
																					"data:image/png;base64," + org.icon
																				}
																				alt="Map Icon"
																			/>
																		) : (
																			<RiTeamFill size={30} color="black" />
																		)}
																	</h3>
																	<p
																		style={{
																			textAlign: "center",
																			fontSize: "0.6rem",
																		}}
																	>
																		{org.name}
																	</p>
																</div>
															);
														})}
													</div>
												</>
											)}
											{(user.userType === "SuperAdmin" ||
												user.userType === "SalesOrgAdmin") && (
												<>
													<h1 className="lead_type_title">Sales Reps</h1>
													<div className="select_deselect">
														<button
															className="select"
															onClick={() => {
																map.setAssignedSalesRepIds(
																	map.salesReps.map((rep) => rep.id),
																);
															}}
														>
															Select All
														</button>
														<button
															className="deselect"
															onClick={() => {
																map.setAssignedSalesRepIds([]);
															}}
														>
															Deselect All
														</button>
													</div>
													<div
														style={{
															display: "flex",
															justifyContent: "flex-start",
															alignItems: "center",
															marginBottom: "1rem",
															width: "100%",
														}}
													>
														<div className="switch" style={{ gridGap: "1rem" }}>
															<div className="switch__2">
																<input
																	onChange={(e) => {
																		if (
																			map.assignedRepToggle === "AssignedTo"
																		) {
																			map.setAssignedRepToggle("UpdatedBy");
																		} else {
																			map.setAssignedRepToggle("AssignedTo");
																		}
																	}}
																	id="switch-3"
																	type="checkbox"
																	checked={
																		map.assignedRepToggle !== "AssignedTo"
																	}
																/>
																<label for="switch-3"></label>
															</div>
														</div>
														<p>
															{map.assignedRepToggle === "AssignedTo"
																? "Owned By"
																: "Updated By"}
														</p>
													</div>

													<div className="MapIconStats">
														{map.salesReps?.map((rep, index) => {
															if (
																rep.status !== "Inactive" &&
																map.assignedSalesOrgs.includes(rep.salesOrgId)
															)
																return (
																	<div
																		style={{
																			// borderRadius: "10px",
																			width: "5rem",
																			height: "5rem",
																		}}
																		onClick={() => {
																			if (
																				map.assignedSalesRepIds.includes(rep.id)
																			) {
																				map.setAssignedSalesRepIds(
																					map.assignedSalesRepIds?.filter(
																						(id) => id !== rep.id,
																					),
																				);
																			} else {
																				map.setAssignedSalesRepIds([
																					...map.assignedSalesRepIds,
																					rep.id,
																				]);
																			}
																		}}
																		className={`MapIconStat ${
																			map.assignedSalesRepIds.includes(rep.id)
																				? "active"
																				: null
																		}`}
																		key={index}
																	>
																		<h3>
																			{rep.profileImage ? (
																				<img
																					style={{ objectFit: "cover" }}
																					src={rep.profileImage?.url}
																					alt="ProfileImage"
																				/>
																			) : (
																				<img
																					style={{ objectFit: "cover" }}
																					src={greyUser}
																					alt="ProfileImage"
																				/>
																			)}
																		</h3>
																		<p
																			style={{
																				textAlign: "center",
																				fontSize: "0.6rem",
																			}}
																		>
																			{rep.firstName + " " + rep.lastName}
																		</p>
																	</div>
																);
														})}
													</div>
													{user.userType === "SuperAdmin" && (
														<div
															style={{
																display: "flex",
																justifyContent: "flex-start",
																alignItems: "center",
																marginBottom: "1rem",
																width: "100%",
															}}
														>
															<div
																className="switch"
																style={{ gridGap: "1rem" }}
															>
																<div className="switch__2">
																	<input
																		onChange={(e) => {
																			if (map.showDeactivatedAccounts) {
																				map.setShowDeactivatedAccounts(false);
																			} else {
																				map.setShowDeactivatedAccounts(true);
																			}
																		}}
																		id="switch-10"
																		type="checkbox"
																		checked={map.showDeactivatedAccounts}
																	/>
																	<label for="switch-10"></label>
																</div>
															</div>
															<p>Show Deactivated Accounts</p>
														</div>
													)}
													<div className="MapIconStats">
														{map.showDeactivatedAccounts &&
															map.salesReps?.map((rep, index) => {
																if (
																	rep.status === "Inactive" &&
																	map.assignedSalesOrgs.includes(rep.salesOrgId)
																)
																	return (
																		<div
																			style={{
																				// borderRadius: "10px",
																				width: "5rem",
																				height: "5rem",
																			}}
																			onClick={() => {
																				if (
																					map.assignedSalesRepIds.includes(
																						rep.id,
																					)
																				) {
																					map.setAssignedSalesRepIds(
																						map.assignedSalesRepIds?.filter(
																							(id) => id !== rep.id,
																						),
																					);
																				} else {
																					map.setAssignedSalesRepIds([
																						...map.assignedSalesRepIds,
																						rep.id,
																					]);
																				}
																			}}
																			className={`MapIconStat ${
																				map.assignedSalesRepIds.includes(rep.id)
																					? "active"
																					: null
																			}`}
																			key={index}
																		>
																			<h3>
																				{rep.profileImage ? (
																					<img
																						style={{ objectFit: "cover" }}
																						src={rep.profileImage?.url}
																						alt="ProfileImage"
																					/>
																				) : (
																					<img
																						style={{ objectFit: "cover" }}
																						src={greyUser}
																						alt="ProfileImage"
																					/>
																				)}
																			</h3>
																			<p
																				style={{
																					textAlign: "center",
																					fontSize: "0.6rem",
																				}}
																			>
																				{rep.firstName + " " + rep.lastName}
																			</p>
																		</div>
																	);
															})}
													</div>
												</>
											)}
											<h1 className="lead_type_title">Lead Status</h1>
											<div className="select_deselect">
												<button
													className="select"
													onClick={() => {
														setAssignedMapIcons(
															map.mapIcons.map((icon) => icon.id),
														);
													}}
												>
													Select All
												</button>
												<button
													className="deselect"
													onClick={() => {
														setAssignedMapIcons([]);
													}}
												>
													Deselect All
												</button>
											</div>
											<div
												style={{
													display: "flex",
													justifyContent: "flex-start",
													alignItems: "center",
													marginBottom: "1rem",
													width: "100%",
												}}
											>
												<div className="switch" style={{ gridGap: "1rem" }}>
													<div className="switch__2">
														<input
															onChange={(e) => {
																if (map.mapIconToggle === "CurrentMapIcon") {
																	map.setMapIconToggle("OnceWas");
																} else {
																	map.setMapIconToggle("CurrentMapIcon");
																}
															}}
															id="switch-5"
															type="checkbox"
															checked={map.mapIconToggle !== "CurrentMapIcon"}
														/>
														<label for="switch-5"></label>
													</div>
												</div>
												<p>
													{map.mapIconToggle === "CurrentMapIcon"
														? "Current Map Icon"
														: "Past Map Icon"}
												</p>
											</div>
											<div className="MapIconStats">
												{map.mapIcons
													?.filter((icon) => icon.iconType === null)
													?.map((icon, index) => {
														return (
															<div
																key={index}
																onClick={() => {
																	if (assignedMapIcons.includes(icon.id)) {
																		setAssignedMapIcons(
																			assignedMapIcons?.filter(
																				(id) => id !== icon.id,
																			),
																		);
																	} else {
																		setAssignedMapIcons([
																			...assignedMapIcons,
																			icon.id,
																		]);
																	}
																}}
																className={`MapIconStat  ${
																	assignedMapIcons?.includes(icon.id)
																		? "active"
																		: null
																}`}
															>
																<h3>
																	<img
																		src={"data:image/png;base64," + icon.image}
																		alt="Map Icon"
																	/>
																</h3>
																<p>{icon.abbreviation}</p>
															</div>
														);
													})}
											</div>
										</div>
									</AccordionDetails>
								</Accordion>
								<h1 className="action_title">Quick Search</h1>
								<div className="action_buttons">
									<button
										className={`action_button ${
											assignedAcountStatus === "" ? "active" : null
										}`}
										onClick={() => {
											setAssignedAcountStatus("");
										}}
									>
										All
									</button>
									<button
										className={`action_button ${
											assignedAcountStatus === "Sold" ? "active" : null
										}`}
										onClick={() => {
											setAssignedAcountStatus("Sold");
										}}
									>
										Sold
									</button>
									<button
										className={`action_button ${
											assignedAcountStatus === "Completed" ? "active" : null
										}`}
										onClick={() => {
											setAssignedAcountStatus("Completed");
										}}
									>
										Completed
									</button>
									<button
										className={`action_button ${
											assignedAcountStatus === "Canceled" ? "active" : null
										}`}
										onClick={() => {
											setAssignedAcountStatus("Canceled");
										}}
									>
										Canceled
									</button>
									<button
										className={`action_button ${
											assignedAcountStatus === "Scheduled" ? "active" : null
										}`}
										onClick={() => {
											if (
												assignedAcountStatus !== "Scheduled" &&
												map.assignedQuickDate !== "Today"
											) {
												map.setAssignedQuickDate("");
												map.setAssignedUpdatedFrom("");
												map.setAssignedUpdatedTo("");
											}
											setAssignedAcountStatus("Scheduled");
										}}
									>
										Installs Pending
									</button>
									<button
										className={`action_button ${
											assignedAcountStatus === "CancelsPending"
												? "active"
												: null
										}`}
										onClick={() => {
											setAssignedAcountStatus("CancelsPending");
										}}
									>
										Cancels Pending
									</button>
								</div>
								<div className="action_date InputsDiv">
									<QuickDate
										future={assignedAcountStatus === "Scheduled"}
										selectQuickDate={map.assignedQuickDate}
										setQuickDateValue={map.setAssignedQuickDate}
										setFrom={map.setAssignedUpdatedFrom}
										setTo={map.setAssignedUpdatedTo}
										from={map.assignedUpdatedFrom}
										to={map.assignedUpdatedTo}
									/>
								</div>
							</div>
						)}
						{(user.userType === "SuperAdmin" ||
							user.userType === "SalesOrgAdmin") && (
							<div className="search_filter_container">
								<button
									disabled={unassignedColor() === "#E6E6E6"}
									style={{
										backgroundColor: unassignedColor(),
									}}
									onClick={() => {
										resetUnassignedFilters();
									}}
									className="reset_all_filters"
								>
									Reset Filters
								</button>
								<Accordion
									sx={{
										boxShadow: "none",
										width: "100%",
									}}
								>
									<AccordionSummary
										sx={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "center",
										}}
									>
										<Typography>Unassigned Leads</Typography>
										<div className="switch">
											<div className="switch__2">
												<input
													onChange={(e) => {
														map.setUnassignedLeadsEnabled(e.target.checked);
													}}
													id="switch-4"
													type="checkbox"
													checked={map.unassignedLeadsEnabled}
												/>
												<label for="switch-4"></label>
											</div>
										</div>
									</AccordionSummary>
									<AccordionDetails>
										<div className="InputsDiv">
											<div className="InputDiv">
												<label htmlFor="assignedConvertedToCustomer">
													Lead Type
												</label>
												<select
													className="p-2 border-2 outline-none rounded-lg"
													name="assignedConvertedToCustomer"
													value={
														unassignedConvertedToCustomer === true
															? "true"
															: unassignedConvertedToCustomer === false
															? "false"
															: "null"
													}
													onChange={(e) => {
														setUnassignedConvertedToCustomer(
															e.target.value === "true"
																? true
																: e.target.value === "false"
																? false
																: null,
														);
													}}
												>
													<option value="null">All</option>
													<option value="true">Customer</option>
													<option value="false">Hot Lead</option>
												</select>
											</div>
											<div className="InputDiv">
												<label>Segment</label>
												<AsyncSelect
													isMulti
													cacheOptions
													defaultOptions={segments.map((segment) => ({
														label: segment,
														value: segment,
													}))}
													loadOptions={(inputValue, callback) => {
														// Simple filter for demonstration; replace with API call if needed
														const filtered = segments
															.filter((segment) =>
																segment
																	.toLowerCase()
																	.includes(inputValue.toLowerCase()),
															)
															.map((segment) => ({
																label: segment,
																value: segment,
															}));
														callback(filtered);
													}}
													onChange={(selectedOptions) => {
														// selectedOptions is an array of { label, value }
														setUnassignedSegment(
															selectedOptions
																? selectedOptions.map((opt) => opt.value)
																: [],
														);
													}}
													value={
														unassignedSegment &&
														Array.isArray(unassignedSegment)
															? unassignedSegment.map((seg) => ({
																	label: seg,
																	value: seg,
															  }))
															: []
													}
													classNamePrefix="react-select"
													placeholder="Select Segment(s)"
												/>
											</div>
											{unassignedConvertedToCustomer !== false && (
												<div className="InputDiv">
													<label htmlFor="accountStatus">Account Status</label>
													<select
														className="p-2 border-2 outline-none rounded-lg"
														name="accountStatus"
														value={unassignedAcountStatus}
														onChange={(e) => {
															e.target.value !== "0"
																? setUnassignedAcountStatus(e.target.value)
																: setUnassignedAcountStatus(null);
														}}
													>
														<option value="0">All</option>
														<option value="Sold">Sold</option>
														<option value={"Completed"}>Completed</option>
														<option value="Canceled">Canceled</option>
														<option value={"Scheduled"}>
															Pending Installs
														</option>
													</select>
												</div>
											)}
											<div className="InputDiv">
												<label htmlFor="DateType">Date Type</label>
												<select
													value={unassignedDateType}
													onChange={(e) => {
														setUnassignedDateType(e.target.value);
													}}
												>
													<option value={"LastUpdated"}>Last Updated</option>
													<option value={"DateSold"}>Date Sold</option>
													<option value={"InstallDate"}>Install Date</option>
													<option value={"AppointmentDate"}>
														Appointment Date
													</option>
												</select>
											</div>

											<SelectionMenu
												tags={tags}
												onChange={(selected) =>
													setUnassignedSelectedTags(selected)
												}
												value={unassignedSelectedTags}
												selectedItems={unassignedSelectedTags}
												setSelectedItems={setUnassignedSelectedTags}
												searchCriteria={searchCriteria}
												setSearchCriteria={setSearchCriteria}
											/>

											<QuickDate
												future={unassignedAcountStatus === "Scheduled"}
												selectQuickDate={map.unassignedQuickdate}
												setQuickDateValue={map.setUnassignedQuickDate}
												from={map.unassignedUpdatedFrom}
												to={map.unassignedUpdatedTo}
												setFrom={map.setUnassignedUpdatedFrom}
												setTo={map.setUnassignedUpdatedTo}
											/>

											<div className="company_selector">
												<FiberCompanySelector
													companyObject={map.unassignedCompanyWithName}
													setCompanyObject={map.setUnassignedCompanyWithName}
													multiple={true}
													setUser={map.setUnassignedFiberCompanyIds}
													placeholder="Select Fiber Company"
												/>
											</div>

											{user.userType === "SuperAdmin" && (
												<>
													<h1 className="lead_type_title">Sales Orgs</h1>
													<div className="select_deselect">
														<button
															className="select"
															onClick={() => {
																map.setUnassignedSalesOrgs(
																	map.salesOrg.map((org) => org.id),
																);
															}}
														>
															Select All
														</button>
														<button
															className="deselect"
															onClick={() => {
																map.setUnassignedSalesOrgs([]);
															}}
														>
															Deselect All
														</button>
													</div>
													<div className="MapIconStats">
														{map.salesOrg?.map((org, index) => {
															return (
																<div
																	style={{
																		// borderRadius: "10px",
																		width: "5rem",
																		height: "5rem",
																	}}
																	onClick={() => {
																		if (
																			map.unassignedSalesOrgs.includes(org.id)
																		) {
																			map.setUnassignedSalesOrgs(
																				map.unassignedSalesOrgs?.filter(
																					(id) => id !== org.id,
																				),
																			);
																		} else {
																			map.setUnassignedSalesOrgs([
																				...map.unassignedSalesOrgs,
																				org.id,
																			]);
																		}
																	}}
																	className={`MapIconStat ${
																		map.unassignedSalesOrgs.includes(org.id)
																			? "active"
																			: null
																	}`}
																	key={index}
																>
																	<h3>
																		{org.icon ? (
																			<img
																				src={
																					"data:image/png;base64," + org.icon
																				}
																				alt="Map Icon"
																			/>
																		) : (
																			<RiTeamFill size={30} color="black" />
																		)}
																	</h3>
																	<p
																		style={{
																			textAlign: "center",
																			fontSize: "0.6rem",
																		}}
																	>
																		{org.name}
																	</p>
																</div>
															);
														})}
													</div>
												</>
											)}
											<h1 className="lead_type_title">Lead Status</h1>
											<div className="select_deselect">
												<button
													className="select"
													onClick={() => {
														setUnassignedMapIcons(
															map.mapIcons.map((icon) => icon.id),
														);
													}}
												>
													Select All
												</button>
												<button
													className="deselect"
													onClick={() => {
														setUnassignedMapIcons([]);
													}}
												>
													Deselect All
												</button>
											</div>

											<div className="MapIconStats">
												{map.mapIcons
													?.filter((icon) => icon.iconType === null)
													.map((icon, index) => {
														return (
															<div
																key={index}
																onClick={() => {
																	if (unassignedMapIcons.includes(icon.id)) {
																		setUnassignedMapIcons(
																			unassignedMapIcons.filter(
																				(id) => id !== icon.id,
																			),
																		);
																	} else {
																		setUnassignedMapIcons([
																			...unassignedMapIcons,
																			icon.id,
																		]);
																	}
																}}
																className={`MapIconStat  ${
																	unassignedMapIcons.includes(icon.id)
																		? "active"
																		: null
																}`}
															>
																<h3>
																	<img
																		src={"data:image/png;base64," + icon.image}
																		alt="Map Icon"
																	/>
																</h3>
																<p>{icon.abbreviation}</p>
															</div>
														);
													})}
											</div>
										</div>
									</AccordionDetails>
								</Accordion>
								<h1 className="action_title">Quick Search</h1>
								<div className="action_buttons">
									<button
										className={`action_button ${
											unassignedAcountStatus === "" ? "active" : null
										}`}
										onClick={() => {
											setUnassignedAcountStatus("");
										}}
									>
										All
									</button>
									<button
										className={`action_button ${
											unassignedAcountStatus === "Sold" ? "active" : null
										}`}
										onClick={() => {
											setUnassignedAcountStatus("Sold");
										}}
									>
										Sold
									</button>
									<button
										className={`action_button ${
											unassignedAcountStatus === "Completed" ? "active" : null
										}`}
										onClick={() => {
											setUnassignedAcountStatus("Completed");
										}}
									>
										Completed
									</button>
									<button
										className={`action_button ${
											unassignedAcountStatus === "Canceled" ? "active" : null
										}`}
										onClick={() => {
											setUnassignedAcountStatus("Canceled");
										}}
									>
										Canceled
									</button>
									<button
										className={`action_button ${
											unassignedAcountStatus === "Scheduled" ? "active" : null
										}`}
										onClick={() => {
											if (
												unassignedAcountStatus !== "Scheduled" &&
												map.unassignedQuickDate !== "Today"
											) {
												map.setUnassignedQuickDate("");
												map.setUnassignedUpdatedFrom("");
												map.setUnassignedUpdatedTo("");
											}
											setUnassignedAcountStatus("Scheduled");
										}}
									>
										Installs Pending
									</button>
									<button
										className={`action_button ${
											unassignedAcountStatus === "CancelsPending"
												? "active"
												: null
										}`}
										onClick={() => {
											setUnassignedAcountStatus("CancelsPending");
										}}
									>
										Cancels Pending
									</button>
								</div>
								<div className="action_date InputsDiv">
									<QuickDate
										future={unassignedAcountStatus === "Scheduled"}
										selectQuickDate={map.unassignedQuickDate}
										setQuickDateValue={map.setUnassignedQuickDate}
										setFrom={map.setUnassignedUpdatedFrom}
										setTo={map.setUnassignedUpdatedTo}
										from={map.unassignedUpdatedFrom}
										to={map.unassignedUpdatedTo}
									/>
								</div>
							</div>
						)}
					</>
				)}

				{user.userType === "SuperAdmin" && (
					<div
						style={{ marginBottom: "1rem", marginTop: "1rem" }}
						className="search_filter_container w-full"
					>
						<div className="InputsDiv">
							<div className="InputDiv">
								<label hmltFor="include_invalid">
									Show Inactive Houses Only
								</label>
								<div
									style={{
										gridColumn: "span 1",
										width: "100%",
									}}
									className="switch"
								>
									<div className="switch__2">
										<input
											onChange={(e) => {
												setShowInactiveLeads(e.target.checked);
											}}
											id="switch-25"
											type="checkbox"
											checked={showInactiveLeads}
										/>
										<label for="switch-25"></label>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	},
);

export default SearchFilters;
